var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 162.89 121.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:url(#New_Gradient_Swatch_2);}.cls-3{fill:#f83d1c;}.cls-4{mix-blend-mode:multiply;}.cls-5{fill:url(#linear-gradient);}.cls-6{fill:url(#linear-gradient-2);}.cls-7{fill:url(#linear-gradient-3);}.cls-8{fill:url(#linear-gradient-4);}.cls-9{fill:#1d1d1b;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_2",
    x1: 42.31,
    y1: 21.29,
    x2: 123.26,
    y2: 102.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f83d1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c72312"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 2.99,
    y1: -212.29,
    x2: 66.72,
    y2: 179.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#fcee21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7931e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 26.98,
    y1: -216.2,
    x2: 90.71,
    y2: 175.28,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 58.78,
    y1: -221.37,
    x2: 122.51,
    y2: 170.11,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 83.32,
    y1: -225.37,
    x2: 147.05,
    y2: 166.11,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.57,23c.05,0,.11,0,.11-.08a.12.12,0,0,0-.11-.11.1.1,0,0,0-.1.11C70.47,22.93,70.5,23,70.57,23Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,23a.18.18,0,0,0,.19-.15.19.19,0,0,0-.19-.19.18.18,0,0,0-.19.19A.17.17,0,0,0,74,23Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.51,23.1a.25.25,0,0,0,.26-.23.27.27,0,0,0-.26-.26.27.27,0,0,0-.27.26A.24.24,0,0,0,77.51,23.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,23.13a.3.3,0,0,0,.3-.26.27.27,0,0,0-.3-.26.26.26,0,0,0-.29.26A.28.28,0,0,0,81,23.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.45,23.13a.29.29,0,0,0,.32-.26.31.31,0,0,0-.32-.29.3.3,0,0,0-.32.29A.29.29,0,0,0,84.45,23.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.92,23.13a.29.29,0,0,0,.32-.26.33.33,0,0,0-.65,0A.3.3,0,0,0,87.92,23.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.39,23.12a.26.26,0,1,0,0-.51.26.26,0,1,0,0,.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.86,23.05a.2.2,0,0,0,.22-.18.22.22,0,0,0-.44,0A.2.2,0,0,0,94.86,23.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.33,23c.1,0,.17-.06.17-.13a.17.17,0,0,0-.17-.16.16.16,0,0,0-.16.16A.15.15,0,0,0,98.33,23Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.81,22.93s0,0,0-.06a.06.06,0,1,0-.11,0A.07.07,0,0,0,101.81,22.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.63,26.06a.16.16,0,0,0,.15-.15.14.14,0,0,0-.15-.13c-.1,0-.17,0-.17.13A.17.17,0,0,0,63.63,26.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.08,26.18a.29.29,0,0,0,.31-.27.29.29,0,0,0-.31-.26.3.3,0,0,0-.29.26A.29.29,0,0,0,67.08,26.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.57,26.27a.38.38,0,0,0,.4-.36.41.41,0,0,0-.81,0A.38.38,0,0,0,70.57,26.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,26.34a.46.46,0,0,0,.48-.43.49.49,0,0,0-1,0A.46.46,0,0,0,74,26.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.51,26.4a.49.49,0,1,0,0-1,.49.49,0,1,0,0,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,26.45a.56.56,0,0,0,.59-.54.55.55,0,0,0-.59-.52.56.56,0,0,0-.6.52A.57.57,0,0,0,81,26.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.45,26.45a.58.58,0,0,0,.62-.54.58.58,0,0,0-.62-.53.59.59,0,0,0-.62.53A.58.58,0,0,0,84.45,26.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.92,26.45a.57.57,0,0,0,.6-.54.61.61,0,0,0-1.2,0A.57.57,0,0,0,87.92,26.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.39,26.44a.57.57,0,0,0,.59-.53.55.55,0,0,0-.59-.51.55.55,0,0,0-.59.51A.57.57,0,0,0,91.39,26.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.86,26.37a.49.49,0,0,0,.52-.46.49.49,0,0,0-.52-.45.49.49,0,0,0-.52.45A.48.48,0,0,0,94.86,26.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.33,26.3a.4.4,0,0,0,.45-.39.42.42,0,0,0-.45-.39.43.43,0,0,0-.45.39A.41.41,0,0,0,98.33,26.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.81,26.22a.32.32,0,0,0,.34-.31.32.32,0,0,0-.34-.3.34.34,0,0,0-.36.3A.34.34,0,0,0,101.81,26.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.28,26.11a.2.2,0,1,0,0-.39.2.2,0,1,0,0,.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.75,26s.09,0,.09-.07a.09.09,0,0,0-.18,0C108.66,26,108.7,26,108.75,26Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.68,29.05a.09.09,0,0,0,.09-.07.08.08,0,0,0-.09-.08.09.09,0,0,0-.09.08S56.64,29.05,56.68,29.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.15,29.23a.29.29,0,0,0,.29-.25.27.27,0,0,0-.29-.27.28.28,0,0,0-.29.27A.29.29,0,0,0,60.15,29.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.63,29.35a.4.4,0,0,0,.43-.37.41.41,0,0,0-.43-.39.42.42,0,0,0-.44.39A.41.41,0,0,0,63.63,29.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.08,29.47a.51.51,0,1,0,0-1,.5.5,0,1,0,0,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.57,29.57a.6.6,0,1,0,0-1.19.6.6,0,1,0,0,1.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,29.67a.7.7,0,1,0-.79-.69A.75.75,0,0,0,74,29.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.51,29.71a.74.74,0,1,0,0-1.48.75.75,0,1,0,0,1.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,29.76a.83.83,0,0,0,.88-.78.89.89,0,1,0-.88.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.45,29.76a.79.79,0,1,0,0-1.57.79.79,0,1,0,0,1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.92,29.76A.83.83,0,0,0,88.8,29a.82.82,0,0,0-.88-.78A.83.83,0,0,0,87,29,.84.84,0,0,0,87.92,29.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.39,29.73a.76.76,0,1,0-.85-.75A.81.81,0,0,0,91.39,29.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.86,29.69a.72.72,0,1,0-.81-.71A.77.77,0,0,0,94.86,29.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.33,29.62a.7.7,0,0,0,.74-.64.71.71,0,0,0-.74-.66.7.7,0,0,0-.73.66A.69.69,0,0,0,98.33,29.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.81,29.51a.58.58,0,0,0,.62-.53.59.59,0,0,0-.62-.55.59.59,0,0,0-.62.55A.58.58,0,0,0,101.81,29.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.28,29.41a.45.45,0,1,0,0-.89.45.45,0,1,0,0,.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.75,29.29a.33.33,0,0,0,.34-.31.31.31,0,0,0-.34-.31.33.33,0,0,0-.36.31A.34.34,0,0,0,108.75,29.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.22,29.14a.18.18,0,0,0,.18-.16.17.17,0,0,0-.18-.16A.18.18,0,0,0,112,29,.2.2,0,0,0,112.22,29.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2,32.15a.12.12,0,0,0,.14-.13.13.13,0,0,0-.14-.11.13.13,0,0,0-.12.11A.12.12,0,0,0,53.2,32.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.68,32.32A.32.32,0,0,0,57,32a.35.35,0,0,0-.69,0A.32.32,0,0,0,56.68,32.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.15,32.49a.46.46,0,1,0,0-.91.46.46,0,1,0,0,.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.63,32.64a.61.61,0,1,0,0-1.21.61.61,0,1,0,0,1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.08,32.78a.8.8,0,0,0,.84-.76.79.79,0,0,0-.84-.72.78.78,0,0,0-.81.72A.79.79,0,0,0,67.08,32.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.57,32.85a.88.88,0,0,0,.94-.83.89.89,0,0,0-.94-.82.9.9,0,0,0-.95.82A.89.89,0,0,0,70.57,32.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,32.94A.92.92,0,1,0,73,32,1,1,0,0,0,74,32.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.51,33a1,1,0,0,0,1.09-1,1.09,1.09,0,0,0-2.17,0A1,1,0,0,0,77.51,33Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,33a1,1,0,1,0-1.13-1A1.08,1.08,0,0,0,81,33Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.45,33.05a1,1,0,1,0-1.16-1A1.09,1.09,0,0,0,84.45,33.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.92,33a1,1,0,1,0-1.14-1A1.09,1.09,0,0,0,87.92,33Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.39,33a1,1,0,1,0-1.12-1A1.06,1.06,0,0,0,91.39,33Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.86,33A.95.95,0,1,0,93.79,32,1,1,0,0,0,94.86,33Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.33,32.9a.88.88,0,1,0,0-1.74.88.88,0,1,0,0,1.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.81,32.82a.8.8,0,1,0-.89-.8A.84.84,0,0,0,101.81,32.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.28,32.69A.71.71,0,0,0,106,32a.77.77,0,0,0-1.52,0A.7.7,0,0,0,105.28,32.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.75,32.57a.57.57,0,0,0,.59-.55.55.55,0,0,0-.59-.52.57.57,0,0,0-.61.52A.59.59,0,0,0,108.75,32.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.22,32.41a.4.4,0,0,0,.43-.39.39.39,0,0,0-.43-.36.4.4,0,0,0-.44.36A.41.41,0,0,0,112.22,32.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.69,32.25a.23.23,0,0,0,.24-.23.23.23,0,0,0-.24-.21.23.23,0,0,0-.24.21A.23.23,0,0,0,115.69,32.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.16,32.05s0,0,0,0h0s0,0,0,0S119.13,32.05,119.16,32.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.74,35.21a.13.13,0,0,0,.14-.12.13.13,0,0,0-.14-.11.12.12,0,0,0-.13.11A.13.13,0,0,0,49.74,35.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2,35.4a.33.33,0,0,0,.36-.31.35.35,0,0,0-.7,0A.33.33,0,0,0,53.2,35.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.68,35.58a.53.53,0,0,0,.57-.49.57.57,0,1,0-.57.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.15,35.77a.74.74,0,0,0,.76-.68.77.77,0,0,0-1.52,0A.74.74,0,0,0,60.15,35.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.63,35.89a.86.86,0,0,0,.91-.8.87.87,0,0,0-.91-.82.82.82,0,1,0,0,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.08,36a.94.94,0,1,0-1-.93A1,1,0,0,0,67.08,36Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.57,36.14a1.13,1.13,0,0,0,1.17-1,1.11,1.11,0,0,0-1.17-1,1.12,1.12,0,0,0-1.19,1A1.14,1.14,0,0,0,70.57,36.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,36.21a1.13,1.13,0,1,0-1.27-1.12A1.19,1.19,0,0,0,74,36.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.51,36.26a1.25,1.25,0,0,0,1.33-1.17,1.34,1.34,0,0,0-2.66,0A1.25,1.25,0,0,0,77.51,36.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,36.28a1.29,1.29,0,0,0,1.37-1.19,1.38,1.38,0,0,0-2.74,0A1.28,1.28,0,0,0,81,36.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.45,36.31a1.31,1.31,0,0,0,1.39-1.22,1.33,1.33,0,0,0-1.39-1.23,1.31,1.31,0,0,0-1.38,1.23A1.3,1.3,0,0,0,84.45,36.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.92,36.29a1.29,1.29,0,0,0,1.38-1.2,1.39,1.39,0,0,0-2.75,0A1.28,1.28,0,0,0,87.92,36.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.39,36.28a1.28,1.28,0,0,0,1.35-1.19,1.36,1.36,0,0,0-2.7,0A1.27,1.27,0,0,0,91.39,36.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.86,36.23a1.15,1.15,0,1,0-1.29-1.14A1.22,1.22,0,0,0,94.86,36.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.33,36.16a1.13,1.13,0,0,0,1.21-1.07A1.12,1.12,0,0,0,98.33,34a1.13,1.13,0,0,0-1.21,1.06A1.15,1.15,0,0,0,98.33,36.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.81,36.08a1,1,0,1,0-1.12-1A1.06,1.06,0,0,0,101.81,36.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.28,36a.88.88,0,1,0,0-1.75.88.88,0,1,0,0,1.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.75,35.83a.79.79,0,0,0,.82-.74.83.83,0,0,0-1.66,0A.8.8,0,0,0,108.75,35.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.22,35.69a.61.61,0,1,0-.67-.6A.64.64,0,0,0,112.22,35.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.69,35.49a.44.44,0,0,0,.47-.4.47.47,0,0,0-.94,0A.44.44,0,0,0,115.69,35.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.16,35.3a.23.23,0,0,0,.24-.21.25.25,0,0,0-.24-.22.23.23,0,0,0-.24.22A.22.22,0,0,0,119.16,35.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.63,35.12l0,0a.23.23,0,0,0,0,0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.27,38.22a.08.08,0,0,0,.08-.06.08.08,0,1,0-.16,0A.08.08,0,0,0,46.27,38.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.74,38.44a.32.32,0,0,0,.35-.28.32.32,0,0,0-.35-.32.3.3,0,1,0,0,.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2,38.65a.54.54,0,0,0,.58-.49.55.55,0,0,0-.58-.52.54.54,0,0,0-.55.52A.53.53,0,0,0,53.2,38.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.68,38.83a.74.74,0,0,0,.79-.67.79.79,0,0,0-1.57,0A.73.73,0,0,0,56.68,38.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.15,39a.93.93,0,0,0,1-.85.91.91,0,0,0-1-.85.9.9,0,0,0-1,.85A.92.92,0,0,0,60.15,39Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.63,39.14a1.06,1.06,0,0,0,1.12-1,1.14,1.14,0,0,0-2.26,0A1.06,1.06,0,0,0,63.63,39.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.08,39.25a1.12,1.12,0,1,0,0-2.21,1.11,1.11,0,1,0,0,2.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.57,39.35a1.22,1.22,0,1,0-1.38-1.19A1.3,1.3,0,0,0,70.57,39.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,39.43a1.3,1.3,0,1,0-1.47-1.27A1.37,1.37,0,0,0,74,39.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.51,39.49A1.36,1.36,0,1,0,76,38.16,1.45,1.45,0,0,0,77.51,39.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,39.53a1.49,1.49,0,0,0,1.58-1.37A1.52,1.52,0,0,0,81,36.75a1.49,1.49,0,0,0-1.57,1.41A1.47,1.47,0,0,0,81,39.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.45,39.53A1.49,1.49,0,0,0,86,38.16a1.6,1.6,0,0,0-3.17,0A1.49,1.49,0,0,0,84.45,39.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.92,39.53a1.49,1.49,0,0,0,1.59-1.37,1.6,1.6,0,0,0-3.18,0A1.49,1.49,0,0,0,87.92,39.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.39,39.52a1.38,1.38,0,1,0,0-2.74,1.38,1.38,0,1,0,0,2.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.86,39.47a1.33,1.33,0,1,0-1.5-1.31A1.42,1.42,0,0,0,94.86,39.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.33,39.4a1.27,1.27,0,1,0-1.42-1.24A1.36,1.36,0,0,0,98.33,39.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.81,39.32a1.18,1.18,0,1,0-1.33-1.16A1.26,1.26,0,0,0,101.81,39.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.28,39.2a1.06,1.06,0,1,0,0-2.1,1.06,1.06,0,1,0,0,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.75,39.07a.93.93,0,1,0-1-.91A1,1,0,0,0,108.75,39.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.22,38.92a.83.83,0,0,0,.86-.76.81.81,0,0,0-.86-.77.82.82,0,0,0-.88.77A.85.85,0,0,0,112.22,38.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.69,38.75a.65.65,0,0,0,.68-.59.66.66,0,0,0-.68-.63.67.67,0,0,0-.69.63A.66.66,0,0,0,115.69,38.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.16,38.55a.41.41,0,1,0,0-.81.45.45,0,0,0-.47.42A.45.45,0,0,0,119.16,38.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.63,38.35a.22.22,0,0,0,.21-.19.19.19,0,0,0-.21-.19.18.18,0,0,0-.2.19A.2.2,0,0,0,122.63,38.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.27,41.47a.28.28,0,0,0,.29-.27.27.27,0,0,0-.29-.26.28.28,0,0,0-.29.26A.29.29,0,0,0,46.27,41.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.74,41.67a.49.49,0,0,0,.52-.47.48.48,0,0,0-.52-.45.49.49,0,0,0-.52.45A.5.5,0,0,0,49.74,41.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2,41.87A.73.73,0,0,0,54,41.2a.75.75,0,0,0-.78-.68.73.73,0,0,0-.75.68A.72.72,0,0,0,53.2,41.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.68,42.06a.87.87,0,1,0-1-.86A.91.91,0,0,0,56.68,42.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.15,42.22a1,1,0,1,0-1.15-1A1.09,1.09,0,0,0,60.15,42.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.63,42.38a1.18,1.18,0,1,0-1.32-1.18A1.25,1.25,0,0,0,63.63,42.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.08,42.48a1.29,1.29,0,1,0-1.44-1.28A1.38,1.38,0,0,0,67.08,42.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.57,42.58A1.39,1.39,0,1,0,69,41.2,1.48,1.48,0,0,0,70.57,42.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,42.66a1.47,1.47,0,1,0-1.66-1.46A1.56,1.56,0,0,0,74,42.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.51,42.72a1.52,1.52,0,1,0-1.73-1.52A1.63,1.63,0,0,0,77.51,42.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,42.77a1.57,1.57,0,1,0-1.76-1.57A1.68,1.68,0,0,0,81,42.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.45,42.77a1.58,1.58,0,1,0,0-3.13,1.58,1.58,0,1,0,0,3.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.92,42.77a1.58,1.58,0,1,0-1.78-1.57A1.68,1.68,0,0,0,87.92,42.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.39,42.74a1.55,1.55,0,1,0-1.75-1.54A1.66,1.66,0,0,0,91.39,42.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.86,42.7a1.5,1.5,0,1,0-1.69-1.5A1.6,1.6,0,0,0,94.86,42.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.33,42.63a1.44,1.44,0,1,0-1.61-1.43A1.52,1.52,0,0,0,98.33,42.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.81,42.53a1.34,1.34,0,1,0-1.52-1.33A1.45,1.45,0,0,0,101.81,42.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.28,42.43a1.32,1.32,0,0,0,1.38-1.23,1.39,1.39,0,0,0-2.76,0A1.32,1.32,0,0,0,105.28,42.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.75,42.29a1.09,1.09,0,1,0,0-2.17,1.09,1.09,0,1,0,0,2.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.22,42.14a.94.94,0,1,0-1.08-.94A1,1,0,0,0,112.22,42.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.69,42a.76.76,0,1,0-.85-.76A.81.81,0,0,0,115.69,42Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.16,41.77a.57.57,0,1,0-.65-.57A.61.61,0,0,0,119.16,41.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.63,41.57a.36.36,0,1,0,0-.72.36.36,0,1,0,0,.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.11,41.33a.14.14,0,0,0,.13-.13.12.12,0,0,0-.13-.11c-.09,0-.14,0-.14.11A.13.13,0,0,0,126.11,41.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.81,44.4a.14.14,0,0,0,.15-.15.16.16,0,0,0-.15-.13.17.17,0,0,0-.17.13C42.64,44.35,42.71,44.4,42.81,44.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.27,44.63a.39.39,0,0,0,.43-.38.43.43,0,0,0-.86,0A.39.39,0,0,0,46.27,44.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.74,44.85a.64.64,0,0,0,.69-.6.65.65,0,0,0-.69-.59.64.64,0,0,0-.68.59A.63.63,0,0,0,49.74,44.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2,45.07a.82.82,0,1,0,0-1.62.81.81,0,1,0,0,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.68,45.26a1,1,0,1,0-1.14-1A1.08,1.08,0,0,0,56.68,45.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.15,45.41a1.25,1.25,0,0,0,1.33-1.16,1.26,1.26,0,0,0-1.33-1.16,1.24,1.24,0,0,0-1.31,1.16A1.23,1.23,0,0,0,60.15,45.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.63,45.56a1.3,1.3,0,1,0,0-2.59,1.31,1.31,0,1,0,0,2.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.08,45.69a1.55,1.55,0,0,0,1.64-1.44,1.64,1.64,0,0,0-3.24,0A1.54,1.54,0,0,0,67.08,45.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.57,45.78a1.53,1.53,0,1,0-1.74-1.53A1.63,1.63,0,0,0,70.57,45.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,45.86a1.61,1.61,0,1,0-1.81-1.61A1.71,1.71,0,0,0,74,45.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.51,45.91a1.65,1.65,0,1,0-1.87-1.66A1.76,1.76,0,0,0,77.51,45.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,46a1.7,1.7,0,1,0-1.92-1.71A1.82,1.82,0,0,0,81,46Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.45,46a1.72,1.72,0,1,0,0-3.4,1.71,1.71,0,1,0,0,3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.92,46A1.71,1.71,0,1,0,86,44.25,1.83,1.83,0,0,0,87.92,46Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.39,45.94a1.69,1.69,0,1,0-1.9-1.69A1.81,1.81,0,0,0,91.39,45.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.86,45.88A1.64,1.64,0,1,0,93,44.25,1.75,1.75,0,0,0,94.86,45.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.33,45.83a1.57,1.57,0,1,0-1.78-1.58A1.69,1.69,0,0,0,98.33,45.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.81,45.74a1.49,1.49,0,1,0,0-3,1.49,1.49,0,1,0,0,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.28,45.61a1.37,1.37,0,1,0,0-2.72,1.37,1.37,0,1,0,0,2.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.75,45.49a1.32,1.32,0,0,0,1.38-1.24,1.3,1.3,0,0,0-1.38-1.2,1.32,1.32,0,0,0-1.4,1.2A1.34,1.34,0,0,0,108.75,45.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.22,45.35a1.09,1.09,0,1,0-1.23-1.1A1.18,1.18,0,0,0,112.22,45.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.69,45.16a.91.91,0,1,0-1-.91A1,1,0,0,0,115.69,45.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.16,45a.78.78,0,0,0,.81-.73.76.76,0,0,0-.81-.68.74.74,0,0,0-.81.68A.77.77,0,0,0,119.16,45Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.63,44.74a.52.52,0,0,0,.55-.49.56.56,0,0,0-1.11,0A.52.52,0,0,0,122.63,44.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.11,44.53a.29.29,0,0,0,.28-.28.28.28,0,0,0-.28-.25.27.27,0,0,0-.3.25A.28.28,0,0,0,126.11,44.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.57,44.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.81,47.58a.28.28,0,0,0,.29-.27.29.29,0,0,0-.29-.26.3.3,0,0,0-.31.26A.29.29,0,0,0,42.81,47.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.27,47.82a.5.5,0,1,0,0-1,.5.5,0,1,0,0,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.74,48a.77.77,0,0,0,.83-.73.83.83,0,0,0-1.65,0A.76.76,0,0,0,49.74,48Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2,48.25a1,1,0,1,0,0-1.88.95.95,0,1,0,0,1.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.68,48.43a1.12,1.12,0,1,0-1.26-1.12A1.2,1.2,0,0,0,56.68,48.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.15,48.6a1.29,1.29,0,1,0-1.45-1.29A1.38,1.38,0,0,0,60.15,48.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.63,48.74A1.44,1.44,0,1,0,62,47.31,1.53,1.53,0,0,0,63.63,48.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.08,48.86a1.55,1.55,0,1,0-1.74-1.55A1.66,1.66,0,0,0,67.08,48.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.57,49a1.65,1.65,0,1,0-1.87-1.64A1.76,1.76,0,0,0,70.57,49Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,49.05a1.74,1.74,0,1,0-2-1.74A1.85,1.85,0,0,0,74,49.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.51,49.09a1.79,1.79,0,1,0-2-1.78A1.9,1.9,0,0,0,77.51,49.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,49.13a1.82,1.82,0,1,0-2.06-1.82A1.94,1.94,0,0,0,81,49.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.45,49.13a1.83,1.83,0,1,0-2.06-1.82A2,2,0,0,0,84.45,49.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.92,49.13a1.83,1.83,0,1,0-2.06-1.82A2,2,0,0,0,87.92,49.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.39,49.11a1.8,1.8,0,1,0-2-1.8A1.93,1.93,0,0,0,91.39,49.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.86,49.07a1.76,1.76,0,1,0-2-1.76A1.88,1.88,0,0,0,94.86,49.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.33,49a1.68,1.68,0,1,0-1.89-1.67A1.79,1.79,0,0,0,98.33,49Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.81,48.91a1.6,1.6,0,1,0-1.8-1.6A1.71,1.71,0,0,0,101.81,48.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.28,48.82a1.51,1.51,0,1,0-1.7-1.51A1.62,1.62,0,0,0,105.28,48.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.75,48.67a1.36,1.36,0,1,0,0-2.71,1.37,1.37,0,1,0,0,2.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.22,48.52a1.28,1.28,0,0,0,1.34-1.21,1.25,1.25,0,0,0-1.34-1.17,1.27,1.27,0,0,0-1.36,1.17A1.3,1.3,0,0,0,112.22,48.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.69,48.33a1,1,0,1,0,0-2,1,1,0,1,0,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.16,48.14a.84.84,0,1,0-.94-.83A.88.88,0,0,0,119.16,48.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.63,47.94a.69.69,0,0,0,.71-.63.67.67,0,0,0-.71-.6.66.66,0,0,0-.7.6A.68.68,0,0,0,122.63,47.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.11,47.69a.41.41,0,0,0,.42-.38.4.4,0,0,0-.42-.36.41.41,0,0,0-.44.36A.42.42,0,0,0,126.11,47.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.57,47.44a.12.12,0,0,0,.12-.13.11.11,0,0,0-.12-.11c-.08,0-.13,0-.13.11A.12.12,0,0,0,129.57,47.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.33,50.47c.06,0,.11,0,.11-.08a.11.11,0,0,0-.11-.11.12.12,0,0,0-.11.11S39.28,50.47,39.33,50.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.81,50.74a.41.41,0,0,0,.41-.35.39.39,0,0,0-.41-.37.38.38,0,0,0-.41.37A.4.4,0,0,0,42.81,50.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.27,51a.64.64,0,0,0,.68-.59.68.68,0,0,0-1.36,0A.64.64,0,0,0,46.27,51Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.74,51.22a.9.9,0,0,0,.95-.83.89.89,0,0,0-.95-.84.88.88,0,0,0-.94.84A.9.9,0,0,0,49.74,51.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2,51.4a1.1,1.1,0,0,0,1.19-1,1.18,1.18,0,0,0-2.35,0A1.09,1.09,0,0,0,53.2,51.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.68,51.58a1.29,1.29,0,0,0,1.38-1.19,1.39,1.39,0,0,0-2.76,0A1.29,1.29,0,0,0,56.68,51.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.15,51.76a1.39,1.39,0,1,0-1.56-1.37A1.49,1.49,0,0,0,60.15,51.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.63,51.9a1.54,1.54,0,1,0-1.74-1.51A1.64,1.64,0,0,0,63.63,51.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.08,52a1.65,1.65,0,1,0-1.84-1.63A1.76,1.76,0,0,0,67.08,52Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.57,52.11a1.85,1.85,0,0,0,2-1.72,2,2,0,1,0-2,1.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,52.21A1.84,1.84,0,1,0,72,50.39,2,2,0,0,0,74,52.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.51,52.22a1.87,1.87,0,1,0-2.11-1.83A2,2,0,0,0,77.51,52.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,52.27a1.91,1.91,0,1,0-2.14-1.88A2,2,0,0,0,81,52.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.45,52.28a1.92,1.92,0,1,0-2.16-1.89A2,2,0,0,0,84.45,52.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.92,52.28a1.92,1.92,0,1,0-2.16-1.89A2,2,0,0,0,87.92,52.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.39,52.26a2,2,0,0,0,2.12-1.87,2.14,2.14,0,0,0-4.24,0A2,2,0,0,0,91.39,52.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.86,52.21a1.85,1.85,0,1,0-2.08-1.82A2,2,0,0,0,94.86,52.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.33,52.15a1.78,1.78,0,1,0,0-3.54,1.78,1.78,0,1,0,0,3.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.81,52.05a1.79,1.79,0,0,0,1.91-1.66,1.92,1.92,0,0,0-3.82,0A1.78,1.78,0,0,0,101.81,52.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.28,52a1.6,1.6,0,1,0-1.79-1.57A1.69,1.69,0,0,0,105.28,52Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.75,51.83a1.47,1.47,0,1,0-1.65-1.44A1.56,1.56,0,0,0,108.75,51.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.22,51.67a1.3,1.3,0,1,0-1.48-1.28A1.4,1.4,0,0,0,112.22,51.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.69,51.5A1.21,1.21,0,0,0,117,50.39a1.23,1.23,0,0,0-1.28-1.14,1.21,1.21,0,0,0-1.28,1.14A1.2,1.2,0,0,0,115.69,51.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.16,51.3a.93.93,0,1,0-1-.91A1,1,0,0,0,119.16,51.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.63,51.1a.77.77,0,0,0,.81-.71.83.83,0,1,0-.81.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.11,50.86a.51.51,0,0,0,.53-.47.54.54,0,0,0-1.07,0A.51.51,0,0,0,126.11,50.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.57,50.59a.25.25,0,0,0,.24-.2.23.23,0,0,0-.24-.22.22.22,0,0,0-.23.22A.23.23,0,0,0,129.57,50.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.33,53.61a.18.18,0,0,0,.19-.18.19.19,0,0,0-.19-.17.2.2,0,0,0-.2.17A.19.19,0,0,0,39.33,53.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.81,53.85a.46.46,0,0,0,.48-.42.46.46,0,0,0-.48-.43.46.46,0,0,0-.5.43A.47.47,0,0,0,42.81,53.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.27,54.13a.7.7,0,1,0-.79-.7A.74.74,0,0,0,46.27,54.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.74,54.35a1,1,0,0,0,1-.92,1,1,0,0,0-2.08,0A1,1,0,0,0,49.74,54.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2,54.56a1.21,1.21,0,0,0,1.27-1.13,1.27,1.27,0,0,0-2.52,0A1.21,1.21,0,0,0,53.2,54.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.68,54.73a1.4,1.4,0,0,0,1.47-1.3,1.48,1.48,0,1,0-1.47,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.15,54.88a1.47,1.47,0,1,0-1.65-1.45A1.56,1.56,0,0,0,60.15,54.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.63,55a1.61,1.61,0,1,0,0-3.19,1.61,1.61,0,1,0,0,3.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.08,55.15a1.73,1.73,0,1,0-1.94-1.72A1.85,1.85,0,0,0,67.08,55.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.57,55.25a1.83,1.83,0,1,0-2.07-1.82A1.94,1.94,0,0,0,70.57,55.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,55.31a1.89,1.89,0,1,0-2.13-1.88A2,2,0,0,0,74,55.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.51,55.36a1.95,1.95,0,1,0,0-3.86,1.94,1.94,0,1,0,0,3.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,55.38a2.08,2.08,0,0,0,2.21-2,2.23,2.23,0,0,0-4.42,0A2.08,2.08,0,0,0,81,55.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.45,55.4a2,2,0,1,0-2.23-2A2.1,2.1,0,0,0,84.45,55.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.92,55.4a2,2,0,1,0-2.22-2A2.11,2.11,0,0,0,87.92,55.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.39,55.38a2,2,0,1,0-2.19-2A2.09,2.09,0,0,0,91.39,55.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.86,55.34a1.92,1.92,0,1,0-2.15-1.91A2,2,0,0,0,94.86,55.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.33,55.27a1.85,1.85,0,1,0,0-3.68,1.85,1.85,0,1,0,0,3.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.81,55.19a1.77,1.77,0,1,0,0-3.52,1.78,1.78,0,1,0,0,3.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.28,55.09a1.67,1.67,0,1,0-1.89-1.66A1.78,1.78,0,0,0,105.28,55.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.75,55a1.63,1.63,0,0,0,1.73-1.53,1.65,1.65,0,0,0-1.73-1.54A1.67,1.67,0,0,0,107,53.43,1.65,1.65,0,0,0,108.75,55Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.22,54.8a1.39,1.39,0,1,0-1.56-1.37A1.47,1.47,0,0,0,112.22,54.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.69,54.63a1.28,1.28,0,0,0,1.37-1.2,1.38,1.38,0,0,0-2.74,0A1.29,1.29,0,0,0,115.69,54.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.16,54.43a1.07,1.07,0,0,0,1.14-1,1.15,1.15,0,0,0-2.28,0A1.06,1.06,0,0,0,119.16,54.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.63,54.23a.85.85,0,0,0,.88-.8.83.83,0,0,0-.88-.78.85.85,0,0,0-.9.78A.86.86,0,0,0,122.63,54.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.11,54a.57.57,0,0,0,.61-.54.62.62,0,0,0-1.23,0A.57.57,0,0,0,126.11,54Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.57,53.72a.31.31,0,0,0,.33-.29.3.3,0,0,0-.33-.29.3.3,0,0,0-.32.29A.31.31,0,0,0,129.57,53.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,53.45s0,0,0,0,0,0,0,0,0,0,0,0S133,53.45,133,53.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.33,56.73a.24.24,0,1,0,0-.47.24.24,0,1,0,0,.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.81,57a.52.52,0,0,0,.54-.47.55.55,0,0,0-1.1,0A.52.52,0,0,0,42.81,57Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.27,57.22a.79.79,0,0,0,.84-.72.85.85,0,0,0-1.68,0A.79.79,0,0,0,46.27,57.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.74,57.47a1,1,0,0,0,1.09-1,1.1,1.1,0,0,0-2.18,0A1,1,0,0,0,49.74,57.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2,57.67a1.27,1.27,0,0,0,1.34-1.17,1.34,1.34,0,0,0-2.66,0A1.28,1.28,0,0,0,53.2,57.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.68,57.84a1.46,1.46,0,0,0,1.54-1.34,1.55,1.55,0,0,0-3.07,0A1.46,1.46,0,0,0,56.68,57.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.15,58a1.63,1.63,0,0,0,1.72-1.5A1.74,1.74,0,1,0,60.15,58Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.63,58.13a1.65,1.65,0,1,0-1.87-1.63A1.75,1.75,0,0,0,63.63,58.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.08,58.27a1.78,1.78,0,1,0-2-1.77A1.91,1.91,0,0,0,67.08,58.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.57,58.34a1.87,1.87,0,1,0,0-3.72,1.88,1.88,0,1,0,0,3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,58.43a1.95,1.95,0,1,0-2.19-1.93A2.07,2.07,0,0,0,74,58.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.51,58.46a2,2,0,1,0-2.23-2A2.11,2.11,0,0,0,77.51,58.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,58.5a2,2,0,1,0-2.27-2A2.15,2.15,0,0,0,81,58.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.45,58.52a2,2,0,1,0-2.28-2A2.17,2.17,0,0,0,84.45,58.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.92,58.5a2,2,0,1,0-2.28-2A2.15,2.15,0,0,0,87.92,58.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.39,58.47a2,2,0,1,0-2.26-2A2.12,2.12,0,0,0,91.39,58.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.86,58.45a2.1,2.1,0,0,0,2.21-2,2.23,2.23,0,0,0-4.42,0A2.1,2.1,0,0,0,94.86,58.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.33,58.38a1.9,1.9,0,1,0-2.14-1.88A2,2,0,0,0,98.33,58.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.81,58.32a2,2,0,0,0,2-1.82,2.08,2.08,0,0,0-4.12,0A2,2,0,0,0,101.81,58.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.28,58.22a1.73,1.73,0,1,0-2-1.72A1.85,1.85,0,0,0,105.28,58.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.75,58.07A1.59,1.59,0,1,0,107,56.5,1.68,1.68,0,0,0,108.75,58.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.22,57.93a1.44,1.44,0,1,0-1.64-1.43A1.53,1.53,0,0,0,112.22,57.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.69,57.74a1.26,1.26,0,1,0-1.42-1.24A1.34,1.34,0,0,0,115.69,57.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.16,57.56a1.07,1.07,0,1,0-1.22-1.06A1.15,1.15,0,0,0,119.16,57.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.63,57.32a.84.84,0,1,0-.95-.82A.9.9,0,0,0,122.63,57.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.11,57.1a.66.66,0,0,0,.7-.6.68.68,0,0,0-.7-.63.69.69,0,0,0-.72.63A.67.67,0,0,0,126.11,57.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.57,56.84a.37.37,0,0,0,.4-.34.38.38,0,0,0-.4-.37.39.39,0,0,0-.41.37A.38.38,0,0,0,129.57,56.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,56.56c.05,0,.1,0,.1-.06s0-.08-.1-.08a.07.07,0,0,0-.08.08S133,56.56,133,56.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.33,59.81a.3.3,0,0,0,.3-.26.3.3,0,0,0-.6,0A.3.3,0,0,0,39.33,59.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.81,60.08a.57.57,0,0,0,.59-.53.56.56,0,0,0-.59-.52.55.55,0,0,0-.6.52A.56.56,0,0,0,42.81,60.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.27,60.32a.78.78,0,1,0-.89-.77A.83.83,0,0,0,46.27,60.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.74,60.56a1,1,0,1,0,0-2,1,1,0,1,0,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2,60.77a1.22,1.22,0,1,0,0-2.43,1.22,1.22,0,1,0,0,2.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.68,61a1.4,1.4,0,1,0-1.57-1.4A1.5,1.5,0,0,0,56.68,61Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.15,61.1a1.56,1.56,0,1,0-1.75-1.55A1.66,1.66,0,0,0,60.15,61.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.63,61.23a1.7,1.7,0,1,0-1.92-1.68A1.81,1.81,0,0,0,63.63,61.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.08,61.36a1.82,1.82,0,1,0-2-1.81A1.94,1.94,0,0,0,67.08,61.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.57,61.43a1.9,1.9,0,1,0-2.16-1.88A2,2,0,0,0,70.57,61.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,61.5a2,2,0,1,0-2.22-2A2.1,2.1,0,0,0,74,61.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.51,61.56a2,2,0,1,0-2.27-2A2.15,2.15,0,0,0,77.51,61.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,61.59a2.06,2.06,0,1,0-2.31-2A2.19,2.19,0,0,0,81,61.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.45,61.6a2.07,2.07,0,1,0-2.33-2.05A2.2,2.2,0,0,0,84.45,61.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.92,61.59a2.06,2.06,0,1,0-2.32-2A2.18,2.18,0,0,0,87.92,61.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.39,61.57a2,2,0,1,0,0-4,2,2,0,1,0,0,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.86,61.51a2,2,0,1,0-2.24-2A2.11,2.11,0,0,0,94.86,61.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.33,61.47a1.94,1.94,0,1,0-2.18-1.92A2.07,2.07,0,0,0,98.33,61.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.81,61.4a1.87,1.87,0,1,0-2.1-1.85A2,2,0,0,0,101.81,61.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.28,61.3a1.76,1.76,0,1,0-2-1.75A1.89,1.89,0,0,0,105.28,61.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.75,61.18a1.64,1.64,0,1,0-1.84-1.63A1.75,1.75,0,0,0,108.75,61.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.22,61a1.48,1.48,0,1,0-1.67-1.46A1.57,1.57,0,0,0,112.22,61Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.69,60.83a1.29,1.29,0,1,0,0-2.56,1.29,1.29,0,1,0,0,2.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.16,60.64a1.11,1.11,0,1,0-1.26-1.09A1.18,1.18,0,0,0,119.16,60.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.63,60.43a.89.89,0,1,0-1-.88A1,1,0,0,0,122.63,60.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.11,60.19a.67.67,0,0,0,.71-.64.66.66,0,0,0-.71-.64.69.69,0,0,0-.75.64A.7.7,0,0,0,126.11,60.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.57,59.93a.38.38,0,1,0,0-.76.38.38,0,1,0,0,.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,59.65c.07,0,.12,0,.12-.1a.11.11,0,0,0-.12-.11.12.12,0,0,0-.13.11C132.91,59.62,133,59.65,133,59.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.33,62.9a.31.31,0,0,0,.32-.3.3.3,0,0,0-.32-.27.3.3,0,0,0-.32.27A.31.31,0,0,0,39.33,62.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.81,63.16a.55.55,0,1,0-.62-.56A.59.59,0,0,0,42.81,63.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.27,63.38a.79.79,0,1,0,0-1.56.79.79,0,1,0,0,1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.74,63.62a1.09,1.09,0,0,0,1.16-1,1.17,1.17,0,0,0-2.32,0A1.09,1.09,0,0,0,49.74,63.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2,63.83a1.23,1.23,0,1,0-1.38-1.23A1.31,1.31,0,0,0,53.2,63.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.68,64a1.52,1.52,0,0,0,1.6-1.42A1.61,1.61,0,1,0,56.68,64Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.15,64.16a1.57,1.57,0,1,0-1.77-1.56A1.67,1.67,0,0,0,60.15,64.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.63,64.32a1.72,1.72,0,1,0-1.94-1.72A1.84,1.84,0,0,0,63.63,64.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.08,64.43a1.83,1.83,0,1,0-2-1.83A2,2,0,0,0,67.08,64.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.57,64.51a1.92,1.92,0,1,0-2.16-1.91A2,2,0,0,0,70.57,64.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,64.57a2,2,0,1,0-2.23-2A2.11,2.11,0,0,0,74,64.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.51,64.62a2,2,0,1,0-2.29-2A2.16,2.16,0,0,0,77.51,64.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,64.66a2.07,2.07,0,1,0-2.33-2.06A2.2,2.2,0,0,0,81,64.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.45,64.69a2.1,2.1,0,1,0-2.36-2.09A2.23,2.23,0,0,0,84.45,64.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.92,64.66a2.07,2.07,0,1,0-2.34-2.06A2.21,2.21,0,0,0,87.92,64.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.39,64.64a2,2,0,1,0-2.31-2A2.18,2.18,0,0,0,91.39,64.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.86,64.61a2,2,0,1,0-2.26-2A2.15,2.15,0,0,0,94.86,64.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.33,64.54a1.95,1.95,0,1,0-2.2-1.94A2.08,2.08,0,0,0,98.33,64.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.81,64.47a1.89,1.89,0,1,0-2.13-1.87A2,2,0,0,0,101.81,64.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.28,64.37a1.78,1.78,0,1,0-2-1.77A1.9,1.9,0,0,0,105.28,64.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.75,64.25a1.65,1.65,0,1,0-1.86-1.65A1.77,1.77,0,0,0,108.75,64.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.22,64.09a1.5,1.5,0,1,0-1.7-1.49A1.59,1.59,0,0,0,112.22,64.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.69,63.93a1.41,1.41,0,0,0,1.48-1.33,1.49,1.49,0,0,0-3,0A1.41,1.41,0,0,0,115.69,63.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.16,63.73a1.13,1.13,0,1,0-1.27-1.13A1.2,1.2,0,0,0,119.16,63.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.63,63.5a1,1,0,0,0,1-.9,1,1,0,0,0-1-.9,1,1,0,0,0-1,.9A1,1,0,0,0,122.63,63.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.11,63.26a.7.7,0,0,0,.74-.66.69.69,0,0,0-.74-.64.7.7,0,0,0-.76.64A.71.71,0,0,0,126.11,63.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.57,63a.41.41,0,0,0,.45-.39.43.43,0,0,0-.45-.39.44.44,0,0,0-.46.39A.43.43,0,0,0,129.57,63Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,62.72a.11.11,0,0,0,.12-.12c0-.07,0-.11-.12-.11a.13.13,0,0,0-.14.11A.14.14,0,0,0,133,62.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.33,65.94a.29.29,0,0,0,.32-.26.3.3,0,0,0-.32-.29.3.3,0,0,0-.32.29C39,65.84,39.15,65.94,39.33,65.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.81,66.2a.56.56,0,0,0,.59-.52.59.59,0,0,0-.59-.56.58.58,0,0,0-.6.56A.55.55,0,0,0,42.81,66.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.27,66.44a.78.78,0,1,0-.89-.76A.85.85,0,0,0,46.27,66.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.74,66.68a1,1,0,1,0-1.14-1A1.09,1.09,0,0,0,49.74,66.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2,66.87a1.21,1.21,0,1,0-1.36-1.19A1.28,1.28,0,0,0,53.2,66.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.68,67.06a1.51,1.51,0,0,0,1.6-1.38,1.61,1.61,0,0,0-3.19,0A1.5,1.5,0,0,0,56.68,67.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.15,67.23a1.57,1.57,0,1,0-1.77-1.55A1.67,1.67,0,0,0,60.15,67.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.63,67.38a1.72,1.72,0,1,0-1.93-1.7A1.82,1.82,0,0,0,63.63,67.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.08,67.47a1.82,1.82,0,1,0-2-1.79A1.94,1.94,0,0,0,67.08,67.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.57,67.58a1.92,1.92,0,1,0-2.16-1.9A2,2,0,0,0,70.57,67.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,67.63a2,2,0,1,0-2.22-1.95A2.1,2.1,0,0,0,74,67.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.51,67.68a2,2,0,1,0-2.28-2A2.16,2.16,0,0,0,77.51,67.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,67.71a2.06,2.06,0,1,0-2.32-2A2.2,2.2,0,0,0,81,67.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.45,67.73a2.08,2.08,0,1,0-2.33-2A2.22,2.22,0,0,0,84.45,67.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.92,67.73a2.09,2.09,0,1,0-2.34-2A2.22,2.22,0,0,0,87.92,67.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.39,67.68a2,2,0,1,0-2.31-2A2.18,2.18,0,0,0,91.39,67.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.86,67.65a2,2,0,1,0-2.25-2A2.13,2.13,0,0,0,94.86,67.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.33,67.6a1.94,1.94,0,1,0-2.18-1.92A2.08,2.08,0,0,0,98.33,67.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.81,67.52a1.88,1.88,0,1,0-2.12-1.84A2,2,0,0,0,101.81,67.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.28,67.42a1.88,1.88,0,0,0,2-1.74,2,2,0,0,0-4,0A1.88,1.88,0,0,0,105.28,67.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.75,67.29a1.64,1.64,0,1,0-1.85-1.61A1.76,1.76,0,0,0,108.75,67.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.22,67.13a1.48,1.48,0,1,0-1.69-1.45A1.58,1.58,0,0,0,112.22,67.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.69,67a1.31,1.31,0,1,0-1.48-1.28A1.39,1.39,0,0,0,115.69,67Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.16,66.77a1.12,1.12,0,1,0,0-2.22,1.12,1.12,0,1,0,0,2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.63,66.56a1,1,0,0,0,1-.88,1,1,0,0,0-1-.92,1,1,0,0,0-1,.92A1,1,0,0,0,122.63,66.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.11,66.33a.66.66,0,1,0,0-1.32.67.67,0,1,0,0,1.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.57,66.07a.4.4,0,1,0,0-.8.44.44,0,0,0-.46.41A.44.44,0,0,0,129.57,66.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,65.78a.11.11,0,0,0,.12-.1c0-.08,0-.14-.12-.14a.14.14,0,0,0-.14.14S133,65.78,133,65.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.33,69a.29.29,0,0,0,.29-.26.29.29,0,0,0-.58,0A.29.29,0,0,0,39.33,69Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.81,69.23a.56.56,0,0,0,.58-.51.55.55,0,0,0-.58-.52.52.52,0,1,0,0,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.27,69.47a.76.76,0,1,0-.86-.75A.81.81,0,0,0,46.27,69.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.74,69.71a1,1,0,1,0,0-2,1,1,0,1,0,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2,69.92a1.19,1.19,0,1,0-1.34-1.2A1.28,1.28,0,0,0,53.2,69.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.68,70.1a1.39,1.39,0,1,0-1.55-1.38A1.49,1.49,0,0,0,56.68,70.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.15,70.26a1.55,1.55,0,1,0,0-3.07,1.55,1.55,0,1,0,0,3.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.63,70.37a1.67,1.67,0,1,0-1.9-1.65A1.78,1.78,0,0,0,63.63,70.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.08,70.52a1.81,1.81,0,1,0,0-3.58,1.8,1.8,0,1,0,0,3.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.57,70.59a1.89,1.89,0,1,0-2.13-1.87A2,2,0,0,0,70.57,70.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,70.67a2,2,0,1,0-2.21-2A2.11,2.11,0,0,0,74,70.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.51,70.71a2,2,0,1,0-2.26-2A2.15,2.15,0,0,0,77.51,70.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,70.75a2.18,2.18,0,0,0,2.29-2,2.32,2.32,0,0,0-4.59,0A2.18,2.18,0,0,0,81,70.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.45,70.75a2.05,2.05,0,1,0-2.31-2A2.18,2.18,0,0,0,84.45,70.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.92,70.75a2.05,2.05,0,1,0-2.3-2A2.17,2.17,0,0,0,87.92,70.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.39,70.72a2,2,0,1,0-2.27-2A2.16,2.16,0,0,0,91.39,70.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.86,70.7a2,2,0,1,0-2.24-2A2.13,2.13,0,0,0,94.86,70.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.33,70.63a1.92,1.92,0,1,0-2.16-1.91A2,2,0,0,0,98.33,70.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.81,70.56a1.85,1.85,0,1,0-2.09-1.84A2,2,0,0,0,101.81,70.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.28,70.46a1.74,1.74,0,1,0,0-3.45,1.74,1.74,0,1,0,0,3.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.75,70.33a1.62,1.62,0,1,0-1.83-1.61A1.73,1.73,0,0,0,108.75,70.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.22,70.17a1.47,1.47,0,1,0,0-2.91,1.47,1.47,0,1,0,0,2.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.69,70a1.3,1.3,0,1,0-1.46-1.3A1.38,1.38,0,0,0,115.69,70Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.16,69.79a1.08,1.08,0,1,0,0-2.14,1.08,1.08,0,1,0,0,2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.63,69.59a.88.88,0,1,0-1-.87A.93.93,0,0,0,122.63,69.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.11,69.35a.68.68,0,0,0,.7-.63.66.66,0,0,0-.7-.62.68.68,0,0,0-.73.62A.69.69,0,0,0,126.11,69.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.57,69.09a.39.39,0,0,0,.42-.37.4.4,0,0,0-.42-.38.41.41,0,0,0-.43.38A.4.4,0,0,0,129.57,69.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,68.81a.1.1,0,1,0,0-.19.1.1,0,0,0-.1.1A.1.1,0,0,0,133,68.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.33,72a.2.2,0,0,0,.22-.18.21.21,0,0,0-.22-.21.21.21,0,0,0-.22.21A.2.2,0,0,0,39.33,72Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.81,72.24a.48.48,0,0,0,.51-.45.49.49,0,0,0-.51-.47.5.5,0,0,0-.53.47A.5.5,0,0,0,42.81,72.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.27,72.5a.73.73,0,1,0,0-1.44.73.73,0,1,0,0,1.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.74,72.73a1,1,0,1,0-1.07-.94A1,1,0,0,0,49.74,72.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2,72.92a1.15,1.15,0,1,0-1.28-1.13A1.21,1.21,0,0,0,53.2,72.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.68,73.11a1.33,1.33,0,1,0-1.49-1.32A1.41,1.41,0,0,0,56.68,73.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.15,73.28a1.51,1.51,0,1,0-1.69-1.49A1.62,1.62,0,0,0,60.15,73.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.63,73.42a1.77,1.77,0,0,0,1.85-1.63,1.87,1.87,0,0,0-3.71,0A1.77,1.77,0,0,0,63.63,73.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.08,73.53a1.76,1.76,0,1,0-2-1.74A1.88,1.88,0,0,0,67.08,73.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.57,73.61a1.85,1.85,0,1,0,0-3.67,1.85,1.85,0,1,0,0,3.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,73.69a1.92,1.92,0,1,0-2.16-1.9A2,2,0,0,0,74,73.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.51,73.74a2,2,0,1,0-2.22-1.95A2.1,2.1,0,0,0,77.51,73.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,73.77a2,2,0,1,0-2.25-2A2.14,2.14,0,0,0,81,73.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.45,73.78a2,2,0,1,0-2.26-2A2.14,2.14,0,0,0,84.45,73.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.92,73.77a2.13,2.13,0,0,0,2.25-2,2.26,2.26,0,0,0-4.5,0A2.13,2.13,0,0,0,87.92,73.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.39,73.74a2.11,2.11,0,0,0,2.24-1.95,2.25,2.25,0,0,0-4.47,0A2.1,2.1,0,0,0,91.39,73.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.86,73.7a1.94,1.94,0,1,0-2.18-1.91A2.06,2.06,0,0,0,94.86,73.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.33,73.65a1.88,1.88,0,1,0-2.12-1.86A2,2,0,0,0,98.33,73.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.81,73.57a1.81,1.81,0,1,0-2-1.78A1.92,1.92,0,0,0,101.81,73.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.28,73.48a1.7,1.7,0,1,0-1.91-1.69A1.82,1.82,0,0,0,105.28,73.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.75,73.32A1.56,1.56,0,1,0,107,71.79,1.66,1.66,0,0,0,108.75,73.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.22,73.16a1.49,1.49,0,0,0,1.58-1.37,1.59,1.59,0,0,0-3.17,0A1.49,1.49,0,0,0,112.22,73.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.69,73a1.24,1.24,0,1,0-1.38-1.23A1.32,1.32,0,0,0,115.69,73Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.16,72.82a1,1,0,1,0,0-2.07,1,1,0,1,0,0,2.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.63,72.59a.85.85,0,0,0,.92-.8.88.88,0,0,0-.92-.84.9.9,0,0,0-.93.84A.87.87,0,0,0,122.63,72.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.11,72.37a.64.64,0,0,0,.67-.58.65.65,0,0,0-.67-.6.64.64,0,0,0-.68.6A.63.63,0,0,0,126.11,72.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.57,72.09a.33.33,0,0,0,.35-.3.35.35,0,1,0-.35.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,71.85s.09,0,.09-.06a.08.08,0,0,0-.09-.08s-.07,0-.07.08A.08.08,0,0,0,133,71.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.33,75a.15.15,0,0,0,.16-.14.14.14,0,0,0-.16-.14.15.15,0,0,0-.16.14A.16.16,0,0,0,39.33,75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.81,75.24a.41.41,0,0,0,.44-.4.42.42,0,0,0-.44-.39.44.44,0,0,0-.47.39A.43.43,0,0,0,42.81,75.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.27,75.49a.66.66,0,1,0-.73-.65A.69.69,0,0,0,46.27,75.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.74,75.72a.93.93,0,0,0,1-.88.9.9,0,0,0-1-.86.93.93,0,0,0-1,.86A1,1,0,0,0,49.74,75.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2,75.91A1.08,1.08,0,1,0,52,74.84,1.14,1.14,0,0,0,53.2,75.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.68,76.08a1.33,1.33,0,0,0,1.43-1.24,1.44,1.44,0,0,0-2.86,0A1.34,1.34,0,0,0,56.68,76.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.15,76.27a1.44,1.44,0,1,0-1.62-1.43A1.54,1.54,0,0,0,60.15,76.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.63,76.4a1.57,1.57,0,1,0-1.77-1.56A1.69,1.69,0,0,0,63.63,76.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.08,76.51a1.69,1.69,0,1,0-1.88-1.67A1.8,1.8,0,0,0,67.08,76.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.57,76.6a1.89,1.89,0,0,0,2-1.76,2,2,0,0,0-4,0A1.88,1.88,0,0,0,70.57,76.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,76.68A1.86,1.86,0,1,0,72,74.84,2,2,0,0,0,74,76.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.51,76.74a1.91,1.91,0,1,0-2.15-1.9A2,2,0,0,0,77.51,76.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,76.76a1.94,1.94,0,1,0-2.18-1.92A2.07,2.07,0,0,0,81,76.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.45,76.78a2,2,0,1,0-2.2-1.94A2.08,2.08,0,0,0,84.45,76.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.92,76.76a1.94,1.94,0,1,0-2.18-1.92A2.07,2.07,0,0,0,87.92,76.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.39,76.75a1.92,1.92,0,1,0-2.16-1.91A2.05,2.05,0,0,0,91.39,76.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.86,76.71a1.89,1.89,0,1,0-2.11-1.87A2,2,0,0,0,94.86,76.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.33,76.66a1.83,1.83,0,1,0-2.06-1.82A1.95,1.95,0,0,0,98.33,76.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.81,76.57a1.74,1.74,0,1,0-2-1.73A1.85,1.85,0,0,0,101.81,76.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.28,76.46a1.63,1.63,0,1,0-1.85-1.62A1.76,1.76,0,0,0,105.28,76.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.75,76.33a1.5,1.5,0,1,0-1.7-1.49A1.61,1.61,0,0,0,108.75,76.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.22,76.18a1.44,1.44,0,0,0,1.51-1.34,1.52,1.52,0,1,0-1.51,1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.69,76a1.17,1.17,0,1,0,0-2.33,1.17,1.17,0,1,0,0,2.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.16,75.82a1.06,1.06,0,0,0,1.11-1,1.11,1.11,0,1,0-1.11,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.63,75.59a.76.76,0,1,0-.85-.75A.8.8,0,0,0,122.63,75.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.11,75.35a.54.54,0,0,0,.57-.51.55.55,0,0,0-.57-.52.55.55,0,0,0-.59.52A.55.55,0,0,0,126.11,75.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.57,75.09a.28.28,0,0,0,.3-.25.31.31,0,0,0-.61,0A.28.28,0,0,0,129.57,75.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.33,78a.06.06,0,0,0,.06,0s0-.05-.06-.05,0,0,0,.05A0,0,0,0,0,39.33,78Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.81,78.19a.32.32,0,0,0,.34-.29.35.35,0,1,0-.34.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.27,78.45a.6.6,0,0,0,.62-.55.62.62,0,0,0-1.23,0A.6.6,0,0,0,46.27,78.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.74,78.67a.84.84,0,0,0,.89-.77.89.89,0,0,0-1.77,0A.84.84,0,0,0,49.74,78.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2,78.87a1,1,0,0,0,1.12-1,1.12,1.12,0,0,0-2.23,0A1,1,0,0,0,53.2,78.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.68,79.06a1.17,1.17,0,1,0-1.33-1.16A1.26,1.26,0,0,0,56.68,79.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.15,79.23a1.34,1.34,0,1,0-1.51-1.33A1.43,1.43,0,0,0,60.15,79.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.63,79.36A1.48,1.48,0,1,0,62,77.9,1.57,1.57,0,0,0,63.63,79.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.08,79.49A1.6,1.6,0,1,0,65.3,77.9,1.71,1.71,0,0,0,67.08,79.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.57,79.58a1.7,1.7,0,1,0-1.93-1.68A1.81,1.81,0,0,0,70.57,79.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,79.65a1.77,1.77,0,1,0-2-1.75A1.89,1.89,0,0,0,74,79.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.51,79.72a2,2,0,0,0,2-1.82,2.08,2.08,0,0,0-4.12,0A2,2,0,0,0,77.51,79.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,79.75a1.87,1.87,0,1,0-2.11-1.85A2,2,0,0,0,81,79.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.45,79.75a1.88,1.88,0,1,0-2.12-1.85A2,2,0,0,0,84.45,79.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.92,79.75a1.87,1.87,0,1,0-2.11-1.85A2,2,0,0,0,87.92,79.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.39,79.72a2,2,0,0,0,2.08-1.82,2.09,2.09,0,0,0-4.15,0A1.94,1.94,0,0,0,91.39,79.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.86,79.7a1.81,1.81,0,1,0-2-1.8A1.93,1.93,0,0,0,94.86,79.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.33,79.62a1.73,1.73,0,1,0-2-1.72A1.86,1.86,0,0,0,98.33,79.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.81,79.52A1.64,1.64,0,1,0,100,77.9,1.75,1.75,0,0,0,101.81,79.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.28,79.43a1.54,1.54,0,1,0,0-3.06,1.54,1.54,0,1,0,0,3.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.75,79.31a1.42,1.42,0,1,0,0-2.81,1.42,1.42,0,1,0,0,2.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.22,79.15a1.34,1.34,0,0,0,1.4-1.25,1.42,1.42,0,0,0-2.82,0A1.35,1.35,0,0,0,112.22,79.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.69,79a1.16,1.16,0,0,0,1.21-1.07,1.23,1.23,0,0,0-2.43,0A1.17,1.17,0,0,0,115.69,79Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.16,78.77a1,1,0,0,0,1-.87,1,1,0,1,0-1,.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.63,78.55a.66.66,0,1,0,0-1.3.66.66,0,1,0,0,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.11,78.32a.42.42,0,1,0-.49-.42A.45.45,0,0,0,126.11,78.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.57,78.06a.18.18,0,0,0,.2-.16.2.2,0,0,0-.2-.19.2.2,0,0,0-.19.19A.18.18,0,0,0,129.57,78.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.81,81.15a.21.21,0,0,0,.21-.21.2.2,0,0,0-.21-.18.21.21,0,0,0-.23.18A.22.22,0,0,0,42.81,81.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.27,81.4a.47.47,0,0,0,.51-.46.51.51,0,0,0-1,0A.47.47,0,0,0,46.27,81.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.74,81.62a.67.67,0,1,0-.76-.68A.71.71,0,0,0,49.74,81.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2,81.83a.94.94,0,0,0,1-.89,1,1,0,0,0-2,0A.94.94,0,0,0,53.2,81.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.68,82a1.06,1.06,0,1,0,0-2.11,1.06,1.06,0,1,0,0,2.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.15,82.17a1.22,1.22,0,1,0,0-2.42,1.22,1.22,0,1,0,0,2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.63,82.32a1.38,1.38,0,1,0-1.55-1.38A1.47,1.47,0,0,0,63.63,82.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.08,82.45a1.61,1.61,0,0,0,1.71-1.51,1.71,1.71,0,0,0-3.39,0A1.6,1.6,0,0,0,67.08,82.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.57,82.53a1.59,1.59,0,1,0-1.8-1.59A1.69,1.69,0,0,0,70.57,82.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,82.61a1.66,1.66,0,1,0-1.88-1.67A1.78,1.78,0,0,0,74,82.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.51,82.67a1.72,1.72,0,1,0,0-3.42,1.72,1.72,0,1,0,0,3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,82.68a1.75,1.75,0,1,0-2-1.74A1.86,1.86,0,0,0,81,82.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.45,82.71a1.77,1.77,0,1,0-2-1.77A1.88,1.88,0,0,0,84.45,82.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.92,82.71a1.77,1.77,0,1,0-2-1.77A1.89,1.89,0,0,0,87.92,82.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.39,82.68a1.74,1.74,0,1,0-2-1.74A1.85,1.85,0,0,0,91.39,82.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.86,82.64a1.7,1.7,0,1,0-1.92-1.7A1.81,1.81,0,0,0,94.86,82.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.33,82.57a1.63,1.63,0,1,0-1.83-1.63A1.74,1.74,0,0,0,98.33,82.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.81,82.49a1.55,1.55,0,1,0,0-3.08,1.55,1.55,0,1,0,0,3.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.28,82.37a1.44,1.44,0,1,0-1.62-1.43A1.53,1.53,0,0,0,105.28,82.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.75,82.23a1.29,1.29,0,1,0-1.47-1.29A1.37,1.37,0,0,0,108.75,82.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.22,82.1a1.15,1.15,0,1,0-1.29-1.16A1.23,1.23,0,0,0,112.22,82.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.69,81.91a1,1,0,0,0,1.09-1,1,1,0,0,0-1.09-1,1,1,0,0,0-1.09,1A1,1,0,0,0,115.69,81.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.16,81.72a.77.77,0,1,0,0-1.53.77.77,0,1,0,0,1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.63,81.5a.55.55,0,1,0-.62-.56A.6.6,0,0,0,122.63,81.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.11,81.25a.32.32,0,0,0,.34-.31.33.33,0,0,0-.34-.29.33.33,0,0,0-.37.29C125.74,81.13,125.89,81.25,126.11,81.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.57,81c.05,0,.07,0,.07-.08a.07.07,0,0,0-.07,0,.1.1,0,0,0-.08,0A.08.08,0,0,0,129.57,81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.81,84.1a.1.1,0,0,0,.08-.08.08.08,0,0,0-.08-.09c-.06,0-.1,0-.1.09A.1.1,0,0,0,42.81,84.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.27,84.32a.31.31,0,1,0-.35-.3A.33.33,0,0,0,46.27,84.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.74,84.53a.56.56,0,0,0,.6-.51.56.56,0,0,0-.6-.53.57.57,0,0,0-.6.53A.56.56,0,0,0,49.74,84.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2,84.75a.74.74,0,1,0-.83-.73A.79.79,0,0,0,53.2,84.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.68,85a1,1,0,0,0,1-.93,1.05,1.05,0,1,0-1,.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.15,85.1A1.09,1.09,0,1,0,58.92,84,1.17,1.17,0,0,0,60.15,85.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.63,85.24a1.23,1.23,0,1,0,0-2.45,1.23,1.23,0,1,0,0,2.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.08,85.37A1.36,1.36,0,1,0,65.56,84,1.46,1.46,0,0,0,67.08,85.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.57,85.47A1.47,1.47,0,1,0,68.92,84,1.55,1.55,0,0,0,70.57,85.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,85.55A1.66,1.66,0,0,0,75.78,84a1.76,1.76,0,0,0-3.49,0A1.66,1.66,0,0,0,74,85.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.51,85.6A1.6,1.6,0,1,0,75.72,84,1.7,1.7,0,0,0,77.51,85.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,85.63A1.63,1.63,0,1,0,79.13,84,1.75,1.75,0,0,0,81,85.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.45,85.65A1.65,1.65,0,1,0,82.58,84,1.76,1.76,0,0,0,84.45,85.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.92,85.63A1.64,1.64,0,1,0,86.07,84,1.75,1.75,0,0,0,87.92,85.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.39,85.62a1.62,1.62,0,1,0,0-3.22,1.62,1.62,0,1,0,0,3.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.86,85.56A1.56,1.56,0,1,0,93.1,84,1.66,1.66,0,0,0,94.86,85.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.33,85.49A1.5,1.5,0,1,0,96.64,84,1.59,1.59,0,0,0,98.33,85.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.81,85.41a1.41,1.41,0,1,0-1.6-1.39A1.5,1.5,0,0,0,101.81,85.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.28,85.29A1.36,1.36,0,0,0,106.73,84a1.38,1.38,0,0,0-1.45-1.31A1.39,1.39,0,0,0,103.81,84,1.38,1.38,0,0,0,105.28,85.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.75,85.17A1.17,1.17,0,1,0,107.42,84,1.25,1.25,0,0,0,108.75,85.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.22,85a1.06,1.06,0,0,0,1.14-1,1.15,1.15,0,0,0-2.29,0A1.07,1.07,0,0,0,112.22,85Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.69,84.85a.88.88,0,0,0,.93-.83.87.87,0,0,0-.93-.84.89.89,0,0,0-1,.84A.9.9,0,0,0,115.69,84.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.16,84.63a.63.63,0,1,0,0-1.25.63.63,0,1,0,0,1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.63,84.42a.41.41,0,1,0-.47-.4A.44.44,0,0,0,122.63,84.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.11,84.2a.2.2,0,0,0,.2-.18.19.19,0,0,0-.2-.18c-.13,0-.22.07-.22.18A.2.2,0,0,0,126.11,84.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.27,87.22a.16.16,0,0,0,.18-.14.18.18,0,1,0-.36,0A.16.16,0,0,0,46.27,87.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.74,87.44a.38.38,0,1,0,0-.75.38.38,0,1,0,0,.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2,87.65a.63.63,0,0,0,.69-.57.64.64,0,0,0-.69-.59.63.63,0,0,0-.66.59A.62.62,0,0,0,53.2,87.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.68,87.83a.77.77,0,1,0,0-1.52.77.77,0,1,0,0,1.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.15,88a1,1,0,1,0-1.06-.93A1,1,0,0,0,60.15,88Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.63,88.16a1.09,1.09,0,1,0,0-2.17,1.09,1.09,0,1,0,0,2.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.08,88.26a1.2,1.2,0,1,0-1.34-1.18A1.29,1.29,0,0,0,67.08,88.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.57,88.37a1.31,1.31,0,1,0-1.47-1.29A1.39,1.39,0,0,0,70.57,88.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,88.43a1.37,1.37,0,1,0-1.56-1.35A1.45,1.45,0,0,0,74,88.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.51,88.49a1.52,1.52,0,0,0,1.62-1.41,1.64,1.64,0,1,0-1.62,1.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,88.53a1.48,1.48,0,1,0-1.66-1.45A1.57,1.57,0,0,0,81,88.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.45,88.57a1.51,1.51,0,1,0-1.69-1.49A1.61,1.61,0,0,0,84.45,88.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.92,88.53a1.48,1.48,0,1,0,0-2.93,1.48,1.48,0,1,0,0,2.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.39,88.51a1.46,1.46,0,1,0-1.64-1.43A1.56,1.56,0,0,0,91.39,88.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.86,88.46a1.41,1.41,0,1,0-1.59-1.38A1.49,1.49,0,0,0,94.86,88.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.33,88.39a1.43,1.43,0,0,0,1.52-1.31,1.53,1.53,0,0,0-3,0A1.42,1.42,0,0,0,98.33,88.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.81,88.31a1.32,1.32,0,0,0,1.4-1.23,1.42,1.42,0,1,0-1.4,1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.28,88.2a1.14,1.14,0,1,0,0-2.26,1.14,1.14,0,1,0,0,2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.75,88.07a1,1,0,1,0-1.15-1A1.08,1.08,0,0,0,108.75,88.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.22,87.92a.91.91,0,0,0,1-.84,1,1,0,0,0-1.9,0A.91.91,0,0,0,112.22,87.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.69,87.73a.72.72,0,0,0,.76-.65.77.77,0,0,0-1.52,0A.72.72,0,0,0,115.69,87.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.16,87.55a.5.5,0,0,0,.54-.47.55.55,0,0,0-1.09,0A.5.5,0,0,0,119.16,87.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.63,87.35a.28.28,0,0,0,.29-.27.28.28,0,0,0-.29-.29.29.29,0,0,0-.29.29A.29.29,0,0,0,122.63,87.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.11,87.11s0,0,0,0,0-.06,0-.06-.07,0-.07.06S126.07,87.11,126.11,87.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.74,90.33a.22.22,0,0,0,.24-.21c0-.12-.1-.2-.24-.2a.21.21,0,0,0-.23.2A.22.22,0,0,0,49.74,90.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2,90.52a.44.44,0,0,0,.48-.4.45.45,0,0,0-.48-.41.44.44,0,0,0-.45.41A.43.43,0,0,0,53.2,90.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.68,90.72a.6.6,0,1,0-.69-.6A.64.64,0,0,0,56.68,90.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.15,90.88a.76.76,0,1,0-.85-.76A.82.82,0,0,0,60.15,90.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.63,91a.91.91,0,1,0-1-.9A1,1,0,0,0,63.63,91Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.08,91.14a1,1,0,1,0-1.14-1A1.09,1.09,0,0,0,67.08,91.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.57,91.26a1.14,1.14,0,1,0-1.29-1.14A1.22,1.22,0,0,0,70.57,91.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,91.31a1.2,1.2,0,1,0-1.37-1.19A1.28,1.28,0,0,0,74,91.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.51,91.37a1.26,1.26,0,1,0,0-2.49,1.26,1.26,0,1,0,0,2.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,91.43a1.39,1.39,0,0,0,1.45-1.31A1.37,1.37,0,0,0,81,88.84a1.39,1.39,0,0,0-1.46,1.28A1.4,1.4,0,0,0,81,91.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.45,91.43a1.31,1.31,0,1,0,0-2.6,1.31,1.31,0,1,0,0,2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.92,91.43a1.31,1.31,0,1,0-1.47-1.31A1.39,1.39,0,0,0,87.92,91.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.39,91.41a1.29,1.29,0,1,0-1.46-1.29A1.39,1.39,0,0,0,91.39,91.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.86,91.35a1.23,1.23,0,1,0-1.39-1.23A1.32,1.32,0,0,0,94.86,91.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.33,91.28a1.23,1.23,0,0,0,1.31-1.16,1.33,1.33,0,1,0-1.31,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.81,91.19a1.07,1.07,0,1,0,0-2.13,1.07,1.07,0,1,0,0,2.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.28,91.09a1,1,0,0,0,1.07-1,1,1,0,0,0-1.07-1,1,1,0,0,0-1.09,1A1,1,0,0,0,105.28,91.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.75,91a.84.84,0,1,0-1-.84A.9.9,0,0,0,108.75,91Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.22,90.79a.68.68,0,1,0-.76-.67A.72.72,0,0,0,112.22,90.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.69,90.62a.5.5,0,1,0,0-1,.5.5,0,1,0,0,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.16,90.44a.33.33,0,0,0,.34-.32.33.33,0,0,0-.34-.31.33.33,0,0,0-.34.31A.34.34,0,0,0,119.16,90.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.63,90.23a.1.1,0,0,0,.1-.11.11.11,0,0,0-.1-.1.1.1,0,0,0-.1.1A.1.1,0,0,0,122.63,90.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.74,93.21h0s0,0,0,0h0S49.72,93.21,49.74,93.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2,93.4a.24.24,0,0,0,.25-.22c0-.12-.11-.19-.25-.19a.21.21,0,0,0-.23.19A.23.23,0,0,0,53.2,93.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.68,93.59a.43.43,0,0,0,.45-.41.42.42,0,0,0-.45-.39.43.43,0,0,0-.45.39A.44.44,0,0,0,56.68,93.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.15,93.75a.62.62,0,0,0,.65-.57.6.6,0,0,0-.65-.56.59.59,0,0,0-.64.56A.61.61,0,0,0,60.15,93.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.63,93.87a.74.74,0,0,0,.79-.69.81.81,0,0,0-1.6,0A.75.75,0,0,0,63.63,93.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.08,94a.84.84,0,1,0-.93-.84A.89.89,0,0,0,67.08,94Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.57,94.11a.93.93,0,1,0-1.06-.93A1,1,0,0,0,70.57,94.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,94.18a1,1,0,1,0-1.14-1A1.07,1.07,0,0,0,74,94.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.51,94.26a1.08,1.08,0,1,0-1.22-1.08A1.16,1.16,0,0,0,77.51,94.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,94.28a1.18,1.18,0,0,0,1.25-1.1A1.27,1.27,0,1,0,81,94.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.45,94.28a1.18,1.18,0,0,0,1.25-1.1,1.27,1.27,0,1,0-1.25,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.92,94.28a1.18,1.18,0,0,0,1.26-1.1,1.27,1.27,0,1,0-1.26,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.39,94.26a1.16,1.16,0,0,0,1.22-1.08,1.23,1.23,0,1,0-1.22,1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.86,94.21a1,1,0,1,0-1.17-1A1.1,1.1,0,0,0,94.86,94.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.33,94.16a1.05,1.05,0,0,0,1.11-1,1,1,0,0,0-1.11-1,1.05,1.05,0,0,0-1.11,1A1.07,1.07,0,0,0,98.33,94.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.81,94.05a.88.88,0,1,0-1-.87A.94.94,0,0,0,101.81,94.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.28,94a.83.83,0,0,0,.86-.78.81.81,0,0,0-.86-.76.82.82,0,0,0-.88.76A.84.84,0,0,0,105.28,94Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.75,93.81a.67.67,0,0,0,.71-.63.71.71,0,0,0-1.42,0A.67.67,0,0,0,108.75,93.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.22,93.66a.48.48,0,1,0-.55-.48A.51.51,0,0,0,112.22,93.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.69,93.48a.31.31,0,0,0,.34-.3.34.34,0,0,0-.68,0A.31.31,0,0,0,115.69,93.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.16,93.3a.12.12,0,1,0,0-.24.12.12,0,1,0,0,.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2,96.26a0,0,0,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.68,96.42a.19.19,0,1,0-.21-.19A.2.2,0,0,0,56.68,96.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.15,96.6a.36.36,0,1,0,0-.71.36.36,0,1,0,0,.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.63,96.73a.52.52,0,0,0,.54-.5.49.49,0,0,0-.54-.46.51.51,0,0,0-.56.46A.54.54,0,0,0,63.63,96.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.08,96.87a.69.69,0,0,0,.72-.64.68.68,0,0,0-.72-.62.67.67,0,0,0-.69.62A.68.68,0,0,0,67.08,96.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.57,97a.79.79,0,0,0,.82-.73.78.78,0,0,0-.82-.72.78.78,0,0,0-.83.72A.8.8,0,0,0,70.57,97Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,97a.83.83,0,0,0,.88-.79.82.82,0,0,0-.88-.77.83.83,0,0,0-.9.77A.84.84,0,0,0,74,97Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.51,97.07a.84.84,0,1,0-1-.84A.89.89,0,0,0,77.51,97.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,97.12a.89.89,0,1,0-1-.89A1,1,0,0,0,81,97.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.45,97.14a.91.91,0,1,0-1-.91A1,1,0,0,0,84.45,97.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.92,97.14a.91.91,0,1,0-1-.91A1,1,0,0,0,87.92,97.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.39,97.12a.88.88,0,1,0,0-1.74.88.88,0,1,0,0,1.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.86,97.05a.82.82,0,1,0-.92-.82A.88.88,0,0,0,94.86,97.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.33,97a.76.76,0,1,0,0-1.5.76.76,0,1,0,0,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.81,96.89a.65.65,0,1,0,0-1.3.66.66,0,1,0,0,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.28,96.78a.54.54,0,1,0,0-1.08.55.55,0,1,0,0,1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.75,96.63a.41.41,0,0,0,.45-.4.43.43,0,0,0-.45-.4.45.45,0,0,0-.47.4A.42.42,0,0,0,108.75,96.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.22,96.5a.28.28,0,0,0,.3-.27.29.29,0,0,0-.3-.26.29.29,0,0,0-.31.26A.29.29,0,0,0,112.22,96.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.69,96.34a.1.1,0,0,0,.1-.11s0-.08-.1-.08-.1,0-.1.08A.1.1,0,0,0,115.69,96.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.15,99.42a.14.14,0,0,0,.14-.12.13.13,0,0,0-.14-.12c-.08,0-.13,0-.13.12A.12.12,0,0,0,60.15,99.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.63,99.57a.3.3,0,0,0,.3-.27.28.28,0,0,0-.3-.27.29.29,0,0,0-.31.27A.3.3,0,0,0,63.63,99.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.08,99.67a.39.39,0,0,0,.43-.37.42.42,0,0,0-.83,0A.38.38,0,0,0,67.08,99.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.57,99.78a.51.51,0,0,0,.53-.48.54.54,0,1,0-.53.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,99.83a.58.58,0,0,0,.62-.53.6.6,0,0,0-.62-.56.59.59,0,0,0-.62.56A.58.58,0,0,0,74,99.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.51,99.93a.66.66,0,0,0,.7-.63.71.71,0,0,0-1.41,0A.67.67,0,0,0,77.51,99.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,100a.71.71,0,0,0,.73-.66.73.73,0,0,0-1.46,0A.7.7,0,0,0,81,100Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.45,100a.72.72,0,0,0,.74-.66.75.75,0,0,0-1.48,0A.71.71,0,0,0,84.45,100Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.92,100a.71.71,0,0,0,.74-.66.75.75,0,0,0-1.48,0A.71.71,0,0,0,87.92,100Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.39,99.93a.67.67,0,0,0,.71-.63.66.66,0,0,0-.71-.61.67.67,0,0,0-.72.61A.68.68,0,0,0,91.39,99.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.86,99.89a.63.63,0,0,0,.68-.59.65.65,0,0,0-.68-.61.64.64,0,0,0-.66.61A.62.62,0,0,0,94.86,99.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.33,99.81a.55.55,0,0,0,.59-.51.56.56,0,0,0-.59-.51.54.54,0,0,0-.57.51A.53.53,0,0,0,98.33,99.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.81,99.73a.43.43,0,1,0,0-.86.43.43,0,1,0,0,.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.28,99.59a.3.3,0,1,0,0-.59.3.3,0,1,0,0,.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.75,99.48a.2.2,0,0,0,.2-.18.19.19,0,0,0-.2-.18.2.2,0,0,0-.22.18A.21.21,0,0,0,108.75,99.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.22,99.35s.06,0,.06,0,0,0-.06,0a0,0,0,1,0,0,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.63,102.38v0h0S63.61,102.38,63.63,102.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.08,102.48c.09,0,.16,0,.16-.13s-.07-.11-.16-.11a.11.11,0,0,0-.12.11A.12.12,0,0,0,67.08,102.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.57,102.58a.25.25,0,0,0,.24-.23.24.24,0,0,0-.48,0A.25.25,0,0,0,70.57,102.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,102.64a.29.29,0,0,0,.32-.29.3.3,0,0,0-.32-.29.31.31,0,0,0-.33.29A.31.31,0,0,0,74,102.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.51,102.72a.4.4,0,0,0,.4-.37.39.39,0,0,0-.4-.35.37.37,0,0,0-.4.35A.38.38,0,0,0,77.51,102.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,102.74a.38.38,0,1,0,0-.75.38.38,0,1,0,0,.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.45,102.74a.41.41,0,0,0,.45-.39.45.45,0,0,0-.9,0A.41.41,0,0,0,84.45,102.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.92,102.74a.41.41,0,0,0,.45-.39.43.43,0,0,0-.45-.39.43.43,0,0,0-.45.39A.41.41,0,0,0,87.92,102.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.39,102.73a.39.39,0,0,0,.41-.38.38.38,0,0,0-.41-.36.4.4,0,0,0-.43.36A.41.41,0,0,0,91.39,102.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.86,102.67a.34.34,0,0,0,.36-.32.35.35,0,0,0-.36-.31.34.34,0,0,0-.35.31A.33.33,0,0,0,94.86,102.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.33,102.61a.28.28,0,0,0,.3-.26.28.28,0,0,0-.3-.26.29.29,0,0,0-.3.26A.28.28,0,0,0,98.33,102.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.81,102.54a.2.2,0,0,0,.19-.19.19.19,0,0,0-.19-.16.17.17,0,0,0-.19.16A.19.19,0,0,0,101.81,102.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.28,102.43s.06,0,.06-.08,0-.07-.06-.07a.1.1,0,0,0-.09.07A.08.08,0,0,0,105.28,102.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,105.45s0,0,0,0,0,0,0,0,0,0,0,0S74,105.45,74,105.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.51,105.49a.08.08,0,0,0,.08-.07c0-.06,0-.09-.08-.09a.08.08,0,0,0-.09.09A.09.09,0,0,0,77.51,105.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,105.52a.11.11,0,0,0,.12-.1.12.12,0,1,0-.24,0A.11.11,0,0,0,81,105.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.45,105.52c.07,0,.14,0,.14-.1a.14.14,0,0,0-.28,0S84.38,105.52,84.45,105.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.92,105.52c.07,0,.14,0,.14-.1a.13.13,0,0,0-.14-.13.12.12,0,0,0-.13.13A.12.12,0,0,0,87.92,105.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.39,105.49c.06,0,.1,0,.1-.07a.09.09,0,0,0-.1-.1.1.1,0,0,0-.11.1S91.33,105.49,91.39,105.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.86,105.49a.08.08,0,0,0,.08-.07c0-.06,0-.09-.08-.09s-.07,0-.07.09A.08.08,0,0,0,94.86,105.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.33,43.35a13,13,0,0,0,4.28-7.26,16.69,16.69,0,0,0,.16-4.89c.53.73,5.23,7,13.35,7.45A18.29,18.29,0,0,0,82.36,25.31c.25,1.44,1.76,9,8.45,12.16,8.06,3.85,28.46-10.59,28.46-10.59s-2.83,7.3,0,11.77c4,6.26,16.42,9,28.92,3.52a29.05,29.05,0,0,0-4.81,5.21c-2.1,2.94-5.88,8.22-4.53,13.61s14.68,11,14.68,11-14.55.17-19.13,4.71A15.28,15.28,0,0,0,130,88.44a18.68,18.68,0,0,0-13.34-3.53A16.39,16.39,0,0,0,102.82,99,15.54,15.54,0,0,0,91.25,87.66c-7.9-1.7-20,12.15-20,12.15s.24-5.28-1.82-9.17A16,16,0,0,0,65,85.3c-5.18-3.36-18.39,1.27-31.14,12.55C39,88.9,43,78.93,38.32,73.93c-5.56-5.92-21.8-5.49-21.8-5.49,1.12-.3,8.87-2.53,12-9.41,2.84-6.21-5.31-18.65-5.31-18.65S42,46.91,46.33,43.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.36,42.7a12.91,12.91,0,0,0,2-2.3c.28-.43.56-.86.79-1.3a10.73,10.73,0,0,0,1.08-2.78,14.88,14.88,0,0,0,.27-1.51,18.81,18.81,0,0,0,.15-3.08h0l-.73-4.62L52,31a18.75,18.75,0,0,0,3.29,3.18,17.25,17.25,0,0,0,4,2.34,15.26,15.26,0,0,0,4.51,1.09,15.47,15.47,0,0,0,4.65-.33,17.77,17.77,0,0,0,8-4.34,18.47,18.47,0,0,0,2.86-3.46,20.63,20.63,0,0,0,1.9-4l1.79-5,.67,5.09h0a16.13,16.13,0,0,0,4.35,9.3,9.48,9.48,0,0,0,1,.89,12.24,12.24,0,0,0,1.1.79c.39.24.8.45,1.2.67l.58.23c.2.07.42.11.63.17a13,13,0,0,0,5.57-.41,47.92,47.92,0,0,0,10.71-4.57,102.52,102.52,0,0,0,9.74-6.21l3.22-2.33-1.21,3.57A20.56,20.56,0,0,0,120,30a18.92,18.92,0,0,0-.35,2.36,11.69,11.69,0,0,0,.39,4.52c0,.18.13.34.19.51a3.48,3.48,0,0,0,.21.48l.26.46a4.63,4.63,0,0,0,.31.46,9.57,9.57,0,0,0,1.59,1.66,14.42,14.42,0,0,0,4.29,2.38A24.49,24.49,0,0,0,137.3,44a32.85,32.85,0,0,0,10.29-2.68l9.52-4.15-7.62,6.51a27.83,27.83,0,0,0-3.41,3.46c-.51.62-1,1.23-1.45,1.92s-.93,1.34-1.36,2a22.46,22.46,0,0,0-2.11,4.14,11.51,11.51,0,0,0-.75,4.24c.05.34,0,.7.12,1l.1.52,0,.12,0,.1.07.2A5.51,5.51,0,0,0,141.8,63a19.81,19.81,0,0,0,3.62,3.08,49.39,49.39,0,0,0,4.36,2.63c1.51.81,3.09,1.59,4.64,2.26l6.3,2.75-7,.15c-1.35,0-2.79.12-4.18.25s-2.78.29-4.15.51a39.74,39.74,0,0,0-4,.84,20.2,20.2,0,0,0-3.63,1.34,8.56,8.56,0,0,0-1.45.92,12.69,12.69,0,0,0-1.2,1.22,12.86,12.86,0,0,0-1.9,3,13.92,13.92,0,0,0-1.28,6.79l.22,3.59-3.16-2.29a17.63,17.63,0,0,0-7.43-3.13,14.47,14.47,0,0,0-7.9,1,14.29,14.29,0,0,0-3.38,2,13.88,13.88,0,0,0-2.69,2.78,16,16,0,0,0-1.85,3.3,16.79,16.79,0,0,0-.92,3.61l-1.26,9-2.32-8.8a14.54,14.54,0,0,0-4.7-7.44,13.12,13.12,0,0,0-4-2.28,10.16,10.16,0,0,0-1.11-.33,4.2,4.2,0,0,0-.54-.13l-.45-.07a6.43,6.43,0,0,0-2.05.19,11,11,0,0,0-2.18.75,21.8,21.8,0,0,0-2.15,1.1,34.65,34.65,0,0,0-4,2.83c-1.3,1-2.54,2.13-3.75,3.26s-2.38,2.34-3.43,3.52L69.4,105l.16-4.86c0-.41,0-.91,0-1.37s0-.94-.1-1.41A20.92,20.92,0,0,0,69,94.61a13.15,13.15,0,0,0-.91-2.56,16,16,0,0,0-1.47-2.41,14.5,14.5,0,0,0-1.84-2.11c-.17-.14-.33-.28-.49-.4s-.31-.2-.46-.29a4.83,4.83,0,0,0-1.11-.4A8.77,8.77,0,0,0,60,86.27a17.81,17.81,0,0,0-3,.48A34.44,34.44,0,0,0,51,88.85a54.83,54.83,0,0,0-5.61,3,72.84,72.84,0,0,0-10.13,7.52l-7.9,7,5.07-8.76a63.19,63.19,0,0,0,5-10.31,24.47,24.47,0,0,0,1.32-5.3,9.89,9.89,0,0,0-.49-5A5.86,5.86,0,0,0,36.87,75a10,10,0,0,0-2.16-1.52,22.3,22.3,0,0,0-5.56-2,45.81,45.81,0,0,0-6.15-1,57.79,57.79,0,0,0-6.28-.27h0l-12.67.22,12.13-3.09a21.43,21.43,0,0,0,4.1-1.55,19,19,0,0,0,3.6-2.36,13.94,13.94,0,0,0,2.77-3.09,9.68,9.68,0,0,0,.52-.88,7.82,7.82,0,0,0,.44-.86A6.3,6.3,0,0,0,28,56.9a13.29,13.29,0,0,0-.34-4,26.87,26.87,0,0,0-1.22-4,49.13,49.13,0,0,0-3.79-7.75h0l-1-1.57,1.94.58c1.86.55,3.78,1.06,5.69,1.52s3.82.88,5.75,1.21a40.68,40.68,0,0,0,5.73.64,15.57,15.57,0,0,0,2.69-.14A3.79,3.79,0,0,0,45.36,42.7Zm2.22,2.11a5.68,5.68,0,0,1-1.85.91,8.55,8.55,0,0,1-.91.22c-.31.06-.59.08-.88.12a19,19,0,0,1-3.3,0c-1.06-.09-2.09-.24-3.11-.42s-2-.39-3-.62c-2-.46-3.91-1-5.82-1.6s-3.78-1.25-5.65-2l1-1h0a52.22,52.22,0,0,1,4.33,7.84,29.12,29.12,0,0,1,1.5,4.2A15.12,15.12,0,0,1,30.48,57a8.17,8.17,0,0,1-.44,2.4,8.81,8.81,0,0,1-.49,1.11,9.56,9.56,0,0,1-.56,1,15.79,15.79,0,0,1-3,3.75,21,21,0,0,1-4.05,2.91,23.78,23.78,0,0,1-4.73,2l-.54-2.87h0a62.2,62.2,0,0,1,6.72.26,50.57,50.57,0,0,1,6.66,1,25.94,25.94,0,0,1,6.48,2.28,13.22,13.22,0,0,1,2.91,2,9,9,0,0,1,2,2.91,12.65,12.65,0,0,1,.72,6.35,27.78,27.78,0,0,1-1.43,5.9A66.89,66.89,0,0,1,35.59,99l-2.83-1.81a75.51,75.51,0,0,1,10.6-7.91A45.3,45.3,0,0,1,56,83.66a22.85,22.85,0,0,1,3.67-.58,13,13,0,0,1,4,.28,8.63,8.63,0,0,1,2,.74,8.45,8.45,0,0,1,.92.58,9.51,9.51,0,0,1,.75.62,17.43,17.43,0,0,1,2.31,2.62,18.8,18.8,0,0,1,1.74,2.86,15.55,15.55,0,0,1,1.12,3.14,22,22,0,0,1,.55,3.16c.05.53.09,1,.11,1.58s0,1,0,1.62l-3.25-1c1.19-1.33,2.38-2.54,3.65-3.75s2.58-2.36,4-3.46A38.51,38.51,0,0,1,82,88.92a23.3,23.3,0,0,1,2.54-1.31,14.91,14.91,0,0,1,2.87-1,10.65,10.65,0,0,1,3.33-.28c.3,0,.59.08.89.13s.51.12.77.18a14.46,14.46,0,0,1,1.46.44A16.71,16.71,0,0,1,99,90a17.54,17.54,0,0,1,5.74,9l-3.58.19a19.41,19.41,0,0,1,1.11-4.33,18.29,18.29,0,0,1,19.9-11.13A21.4,21.4,0,0,1,127,85.22a21.79,21.79,0,0,1,4.26,2.42l-2.94,1.3a16.94,16.94,0,0,1,1.57-8.17,16.38,16.38,0,0,1,2.36-3.65,14.25,14.25,0,0,1,1.65-1.65A11.41,11.41,0,0,1,136,74.16a22.74,22.74,0,0,1,4.36-1.61,45,45,0,0,1,4.42-.92c1.47-.23,2.95-.4,4.43-.53s2.94-.22,4.48-.25l-.74,2.9c-1.72-.76-3.32-1.55-4.93-2.42a50.53,50.53,0,0,1-4.67-2.84,22.72,22.72,0,0,1-4.23-3.65,8.37,8.37,0,0,1-1.57-2.55l-.12-.38-.06-.19,0-.17-.13-.68c-.09-.46-.09-.92-.14-1.37a14.09,14.09,0,0,1,.93-5.26,24.77,24.77,0,0,1,2.39-4.67c.46-.73,1-1.44,1.45-2.13s1-1.42,1.59-2.09a30.46,30.46,0,0,1,3.8-3.82l1.89,2.36a36.6,36.6,0,0,1-11.45,3,27.84,27.84,0,0,1-12-1.42,17.22,17.22,0,0,1-5.25-3,12.46,12.46,0,0,1-2-2.22c-.13-.21-.28-.4-.4-.63l-.35-.67a4.59,4.59,0,0,1-.29-.69c-.08-.23-.17-.46-.24-.69a14,14,0,0,1-.24-5.44,20.6,20.6,0,0,1,.51-2.6,20,20,0,0,1,.82-2.56l2,1.25a107.28,107.28,0,0,1-10.28,6c-1.78.92-3.59,1.78-5.47,2.55a39.82,39.82,0,0,1-5.82,2,22.87,22.87,0,0,1-3.14.55,11.94,11.94,0,0,1-3.31-.15c-.28-.07-.56-.13-.84-.22l-.8-.31c-.47-.24-.94-.48-1.39-.75s-.88-.56-1.28-.88-.81-.63-1.16-1l-.54-.53c-.18-.18-.33-.37-.5-.56-.34-.37-.63-.76-.93-1.15s-.54-.81-.82-1.21-.5-.84-.7-1.27a22.66,22.66,0,0,1-2-5.33h0l2.46.09A19.24,19.24,0,0,1,82,30.64a20.86,20.86,0,0,1-3.12,4.13A19.13,19.13,0,0,1,74.53,38a18.92,18.92,0,0,1-11,2.37A17.22,17.22,0,0,1,58,39a19.64,19.64,0,0,1-4.61-2.89,19.41,19.41,0,0,1-3.53-3.84l2.39-.75h0A15.61,15.61,0,0,1,52.45,35a15.11,15.11,0,0,1-.16,1.77,13.86,13.86,0,0,1-.43,1.8,13,13,0,0,1-1.62,3.36A12.23,12.23,0,0,1,49,43.44,13.77,13.77,0,0,1,47.58,44.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M66.78,28.45l-6-14.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.78,28.45,59.26,14.69A1.37,1.37,0,0,1,60,12.76a1.75,1.75,0,0,1,2.19.68,2.72,2.72,0,0,1,.11.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M69.91,23.66,67,1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.91,23.66l-4.57-22A1.47,1.47,0,0,1,66.65,0a1.63,1.63,0,0,1,1.9,1.16.63.63,0,0,1,0,.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M100.41,27.15,108,13.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.41,27.15l6.1-14.29a1.71,1.71,0,0,1,2.11-.84,1.4,1.4,0,0,1,.95,1.86,1.12,1.12,0,0,1-.13.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M18.4,54.48,1.79,50.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4,54.48l-17-2.7A1.47,1.47,0,0,1,0,50.1a1.64,1.64,0,0,1,1.9-1.17l.3.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M133,34.16l12.41-6.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,34.16l11.58-7.69a1.79,1.79,0,0,1,2.3.29,1.33,1.33,0,0,1-.33,2,1.41,1.41,0,0,1-.32.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M56.07,96.06,50,110.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.07,96.06l-4.51,14.75a1.67,1.67,0,0,1-2,1,1.44,1.44,0,0,1-1.16-1.77,2,2,0,0,1,.11-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M39.31,35.24,29.24,22.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.31,35.24,27.92,23.73a1.33,1.33,0,0,1,.15-2,1.81,1.81,0,0,1,2.32.14l.18.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M144.1,82.15l17,6.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.1,82.15l17.68,5.25a1.42,1.42,0,0,1,1,1.83,1.7,1.7,0,0,1-2.08.9,1.17,1.17,0,0,1-.26-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M114.47,93.18l10.71,13.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.47,93.18l12,12.57a1.33,1.33,0,0,1-.2,2,1.77,1.77,0,0,1-2.3-.17,1.73,1.73,0,0,1-.17-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M89.69,97.85l.75,14.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.69,97.85l2.38,14.33a1.49,1.49,0,0,1-1.39,1.64,1.63,1.63,0,0,1-1.86-1.23,1.31,1.31,0,0,1,0-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M84.52,101.65,80.6,119.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.52,101.65,82.21,120a1.6,1.6,0,0,1-1.81,1.27A1.49,1.49,0,0,1,79,119.69a.85.85,0,0,1,0-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M123.84,95.7l15.62,13.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.84,95.7l16.76,12.4a1.33,1.33,0,0,1,.2,2,1.79,1.79,0,0,1-2.3.18l-.18-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M131.91,30.41l12.83-12.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.91,30.41l11.86-13.29a1.63,1.63,0,0,1,2.2-.37,1.49,1.49,0,0,1,0,2.15,1.58,1.58,0,0,1-.23.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M28.92,85.83,9.59,99.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.92,85.83,10.61,100.59a1.79,1.79,0,0,1-2.31-.09,1.32,1.32,0,0,1,.11-2l.16-.12Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.4,47.36a49,49,0,0,1,13.65-2.53q7.26,0,7.15,5.05Q62,60.05,45.11,70.9,43.93,77.45,43.39,83l-8.55,2.37q.16-1.18,1.29-7.2L38.5,65.47Q41.67,47.89,41.4,47.36ZM48.17,56c-.25,1-.48,2-.7,3l-.59,3c3.33-1.65,5.48-3.38,6.45-5.21a1.72,1.72,0,0,0,.21-.7c0-.61-.44-.91-1.34-.91A15,15,0,0,0,48.17,56Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.48,43.33q5.7,0,8.06,6.34a20.12,20.12,0,0,1,1.24,7.2A33.2,33.2,0,0,1,86.65,65,38.68,38.68,0,0,1,79.77,78.9q-6,7.74-12.63,7.74-5.74,0-8.17-6.34a19.78,19.78,0,0,1-1.18-7A32.76,32.76,0,0,1,59,65,39.16,39.16,0,0,1,65.8,51.12Q71.77,43.34,78.48,43.33ZM76.55,56.66q-3,0-6,4.83A26.1,26.1,0,0,0,67.09,69a14.75,14.75,0,0,0-.49,3.5,5.75,5.75,0,0,0,1.08,3.6,4.13,4.13,0,0,0,3.44,1.55c2,0,3.81-1,5.43-3.17a16,16,0,0,0,2.79-6,19.91,19.91,0,0,0,.43-8C79.34,57.94,78.27,56.66,76.55,56.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.14,45.37a230.77,230.77,0,0,0-10.8,37.51l-12,2,2-19.72-5,18.27-11.46,2.1a288.37,288.37,0,0,0,2.53-37.08l10.21-1.94-2.1,23.54,7-26.12,5.49-.81-3.74,33.16L113.7,47Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.35,76.59a5.16,5.16,0,0,1,3.33.54,2.82,2.82,0,0,1,1.72,2.69q0,2.48-2.63,4.51a9,9,0,0,1-4.46,1.94,5.75,5.75,0,0,1-3.34-.43,2.84,2.84,0,0,1-1.66-2.69,6,6,0,0,1,2.52-4.57A8.94,8.94,0,0,1,125.35,76.59Zm6.07-33.42,11.23,1.88q-4.46,8-6.55,12.52A106.18,106.18,0,0,0,131,71l-7.46-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.05,44.83q7.26,0,7.15,5.05Q62,60.05,45.11,70.9,43.93,77.45,43.39,83l-8.55,2.37q.16-1.18,1.29-7.2L38.5,65.47q3.16-17.58,2.9-18.11a49,49,0,0,1,13.65-2.53M46.88,61.92c3.33-1.65,5.48-3.38,6.45-5.21a1.72,1.72,0,0,0,.21-.7c0-.61-.44-.91-1.34-.91a15,15,0,0,0-4,.86c-.25,1-.48,2-.7,3l-.59,3m8.17-18.09A50.61,50.61,0,0,0,41.11,46.4L40,46.74l.44.89c0,.76-.47,4.16-2.91,17.66L35.15,78c-.76,4.07-1.19,6.44-1.3,7.25l-.2,1.5,1.46-.4L43.65,84l.67-.19.06-.68c.34-3.56.89-7.47,1.63-11.64C57.3,64.19,63.08,56.92,63.2,49.9a5.36,5.36,0,0,0-1.44-4c-1.36-1.39-3.55-2.06-6.71-2.06ZM49,56.75a12.09,12.09,0,0,1,3.2-.65l.3,0a.9.9,0,0,1-.07.14A10.64,10.64,0,0,1,48.28,60l.17-.87c.17-.8.36-1.61.55-2.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.48,43.33q5.7,0,8.06,6.34a20.12,20.12,0,0,1,1.24,7.2A33.2,33.2,0,0,1,86.65,65,38.68,38.68,0,0,1,79.77,78.9q-6,7.74-12.63,7.74-5.74,0-8.17-6.34a19.78,19.78,0,0,1-1.18-7A32.76,32.76,0,0,1,59,65,39.16,39.16,0,0,1,65.8,51.12q6-7.78,12.68-7.79M71.12,77.61c2,0,3.81-1,5.43-3.17a16,16,0,0,0,2.79-6,19.91,19.91,0,0,0,.43-8c-.43-2.58-1.5-3.86-3.22-3.86q-3,0-6,4.83A26.1,26.1,0,0,0,67.09,69a14.75,14.75,0,0,0-.49,3.5,5.75,5.75,0,0,0,1.08,3.6,4.13,4.13,0,0,0,3.44,1.55m7.36-35.28c-4.78,0-9.32,2.75-13.48,8.18a40.33,40.33,0,0,0-7,14.27,33.53,33.53,0,0,0-1.22,8.53A20.68,20.68,0,0,0,58,80.66c1.77,4.63,4.83,7,9.1,7,4.75,0,9.27-2.73,13.42-8.13a39.94,39.94,0,0,0,7.06-14.22,34.26,34.26,0,0,0,1.16-8.42,21.37,21.37,0,0,0-1.3-7.55c-1.73-4.64-4.76-7-9-7ZM71.12,76.61a3.16,3.16,0,0,1-2.66-1.18,4.72,4.72,0,0,1-.86-3,13.77,13.77,0,0,1,.46-3.26A24.93,24.93,0,0,1,71.37,62c1.84-2.91,3.58-4.38,5.18-4.38.47,0,1.73,0,2.23,3a18.94,18.94,0,0,1-.41,7.54,15.3,15.3,0,0,1-2.62,5.61c-1.42,1.87-2.94,2.77-4.63,2.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,43.16l-3.74,33.16L113.7,47l10.44-1.61a230.77,230.77,0,0,0-10.8,37.51l-12,2,2-19.72-5,18.27-11.46,2.1a288.37,288.37,0,0,0,2.53-37.08l10.21-1.94-2.1,23.54,7-26.12,5.49-.81M111.1,42l-1.28.19-5.5.8-.65.1-.17.63-4,14.95,1.07-12,.12-1.32-1.3.25L89.18,47.5l-.82.16v.83a289.72,289.72,0,0,1-2.52,36.95l-.17,1.36L87,86.55l11.46-2.1.62-.11.16-.61,1.83-6.68-.79,7.77-.13,1.31,1.29-.22,12-2,.68-.12.14-.68a231.81,231.81,0,0,1,10.75-37.35l.61-1.6-1.7.26L113.55,46l-.66.1-.16.64L108.85,62,111,43.28,111.1,42Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.42,43.17l11.23,1.88q-4.46,8-6.55,12.52A106.18,106.18,0,0,0,131,71l-7.46-.32,7.84-27.46m-5.16,33.36a4.93,4.93,0,0,1,2.42.6,2.82,2.82,0,0,1,1.72,2.69q0,2.48-2.63,4.51a9,9,0,0,1-4.46,1.94,7.57,7.57,0,0,1-1,.07,5.18,5.18,0,0,1-2.3-.5,2.84,2.84,0,0,1-1.66-2.69,6,6,0,0,1,2.52-4.57,8.94,8.94,0,0,1,4.52-2,7.19,7.19,0,0,1,.91-.06M130.7,42l-.24.86-7.85,27.46-.34,1.22,1.26.06L131,72l.77,0,.23-.74A106.25,106.25,0,0,1,137,58c1.39-3,3.58-7.17,6.53-12.46l.69-1.23-1.4-.24-11.23-1.88L130.7,42Zm-4.44,33.5h0a7.61,7.61,0,0,0-1.05.07,9.85,9.85,0,0,0-5,2.21,6.92,6.92,0,0,0-2.89,5.34,3.84,3.84,0,0,0,2.21,3.58,6.07,6.07,0,0,0,2.75.61,9.46,9.46,0,0,0,1.17-.08,10.13,10.13,0,0,0,4.95-2.14c2-1.55,3-3.34,3-5.3a3.82,3.82,0,0,0-2.27-3.58,5.82,5.82,0,0,0-2.87-.71Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M40.9,44.36a49,49,0,0,1,13.65-2.53q7.26,0,7.15,5.05-.16,10.17-17.09,21Q43.43,74.45,42.89,80l-8.55,2.37q.16-1.18,1.29-7.2L38,62.47Q41.17,44.89,40.9,44.36ZM47.67,53c-.25,1-.48,2-.7,3l-.59,3c3.33-1.65,5.48-3.38,6.45-5.21A1.72,1.72,0,0,0,53,53c0-.61-.44-.91-1.34-.91A15,15,0,0,0,47.67,53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M78,40.33q5.7,0,8.06,6.34a20.12,20.12,0,0,1,1.24,7.2A33.2,33.2,0,0,1,86.15,62,38.68,38.68,0,0,1,79.27,75.9q-6,7.74-12.63,7.74-5.74,0-8.17-6.34a19.78,19.78,0,0,1-1.18-7A32.76,32.76,0,0,1,58.47,62,39.16,39.16,0,0,1,65.3,48.12Q71.27,40.34,78,40.33ZM76.05,53.66q-3,0-6,4.83A26.1,26.1,0,0,0,66.59,66a14.75,14.75,0,0,0-.49,3.5,5.75,5.75,0,0,0,1.08,3.6,4.13,4.13,0,0,0,3.44,1.55c2,0,3.81-1,5.43-3.17a16,16,0,0,0,2.79-6,19.91,19.91,0,0,0,.43-8C78.84,54.94,77.77,53.66,76.05,53.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M123.64,42.37a230.77,230.77,0,0,0-10.8,37.51l-12,2,2-19.72-5,18.27-11.46,2.1a288.37,288.37,0,0,0,2.53-37.08l10.21-1.94L97,67.09,104,41l5.49-.81-3.74,33.16L113.2,44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M124.85,73.59a5.16,5.16,0,0,1,3.33.54,2.82,2.82,0,0,1,1.72,2.69q0,2.48-2.63,4.51a9,9,0,0,1-4.46,1.94,5.75,5.75,0,0,1-3.34-.43,2.84,2.84,0,0,1-1.66-2.69,6,6,0,0,1,2.52-4.57A8.94,8.94,0,0,1,124.85,73.59Zm6.07-33.42,11.23,1.88q-4.46,8-6.55,12.52A106.18,106.18,0,0,0,130.54,68l-7.46-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M54.55,41.83q7.26,0,7.15,5.05-.16,10.17-17.09,21Q43.43,74.45,42.89,80l-8.55,2.37q.16-1.18,1.29-7.2L38,62.47q3.16-17.58,2.9-18.11a49,49,0,0,1,13.65-2.53M46.38,58.92c3.33-1.65,5.48-3.38,6.45-5.21A1.72,1.72,0,0,0,53,53c0-.61-.44-.91-1.34-.91a15,15,0,0,0-4,.86c-.25,1-.48,2-.7,3l-.59,3m8.17-18.09A50.61,50.61,0,0,0,40.61,43.4l-1.13.34.44.89c0,.76-.47,4.16-2.91,17.66L34.65,75c-.76,4.07-1.19,6.44-1.3,7.25l-.2,1.5,1.46-.4L43.15,81l.67-.19.06-.68c.34-3.56.89-7.47,1.63-11.64C56.8,61.19,62.58,53.92,62.7,46.9a5.36,5.36,0,0,0-1.44-4c-1.36-1.39-3.55-2.06-6.71-2.06Zm-6,12.92a12.09,12.09,0,0,1,3.2-.65l.3,0a.9.9,0,0,1-.07.14A10.64,10.64,0,0,1,47.78,57l.17-.87c.17-.8.36-1.61.55-2.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M78,40.33q5.7,0,8.06,6.34a20.12,20.12,0,0,1,1.24,7.2A33.2,33.2,0,0,1,86.15,62,38.68,38.68,0,0,1,79.27,75.9q-6,7.74-12.63,7.74-5.74,0-8.17-6.34a19.78,19.78,0,0,1-1.18-7A32.76,32.76,0,0,1,58.47,62,39.16,39.16,0,0,1,65.3,48.12q6-7.78,12.68-7.79M70.62,74.61c2,0,3.81-1,5.43-3.17a16,16,0,0,0,2.79-6,19.91,19.91,0,0,0,.43-8c-.43-2.58-1.5-3.86-3.22-3.86q-3,0-6,4.83A26.1,26.1,0,0,0,66.59,66a14.75,14.75,0,0,0-.49,3.5,5.75,5.75,0,0,0,1.08,3.6,4.13,4.13,0,0,0,3.44,1.55M78,39.33c-4.78,0-9.32,2.75-13.48,8.18a40.33,40.33,0,0,0-7,14.27,33.53,33.53,0,0,0-1.22,8.53,20.68,20.68,0,0,0,1.25,7.35c1.77,4.63,4.83,7,9.1,7,4.75,0,9.27-2.73,13.42-8.13a39.94,39.94,0,0,0,7.06-14.22,34.26,34.26,0,0,0,1.16-8.42A21.37,21.37,0,0,0,87,46.32c-1.73-4.64-4.76-7-9-7ZM70.62,73.61A3.16,3.16,0,0,1,68,72.43a4.72,4.72,0,0,1-.86-3,13.77,13.77,0,0,1,.46-3.26A24.93,24.93,0,0,1,70.87,59c1.84-2.91,3.58-4.38,5.18-4.38.47,0,1.73,0,2.23,3a18.94,18.94,0,0,1-.41,7.54,15.3,15.3,0,0,1-2.62,5.61c-1.42,1.87-2.94,2.77-4.63,2.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M109.46,40.16l-3.74,33.16L113.2,44l10.44-1.61a230.77,230.77,0,0,0-10.8,37.51l-12,2,2-19.72-5,18.27-11.46,2.1a288.37,288.37,0,0,0,2.53-37.08l10.21-1.94L97,67.09,104,41l5.49-.81M110.6,39l-1.28.19-5.5.8-.65.1-.17.63L99,55.66l1.07-12,.12-1.32-1.3.25L88.68,44.5l-.82.16v.83a289.72,289.72,0,0,1-2.52,36.95l-.17,1.36,1.34-.25L98,81.45l.62-.11.16-.61,1.83-6.68-.79,7.77-.13,1.31,1.29-.22,12-2,.68-.12.14-.68a231.81,231.81,0,0,1,10.75-37.35l.61-1.6-1.7.26L113.05,43l-.66.1-.16.64L108.35,59l2.1-18.69L110.6,39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M130.92,40.17l11.23,1.88q-4.46,8-6.55,12.52A106.18,106.18,0,0,0,130.54,68l-7.46-.32,7.84-27.46m-5.16,33.36a4.93,4.93,0,0,1,2.42.6,2.82,2.82,0,0,1,1.72,2.69q0,2.48-2.63,4.51a9,9,0,0,1-4.46,1.94,7.57,7.57,0,0,1-1,.07,5.18,5.18,0,0,1-2.3-.5,2.84,2.84,0,0,1-1.66-2.69,6,6,0,0,1,2.52-4.57,8.94,8.94,0,0,1,4.52-2,7.19,7.19,0,0,1,.91-.06M130.2,39l-.24.86-7.85,27.46-.34,1.22,1.26.06,7.47.32.77,0,.23-.74a106.25,106.25,0,0,1,5-13.25c1.39-3,3.58-7.17,6.53-12.46l.69-1.23-1.4-.24-11.23-1.88L130.2,39Zm-4.44,33.5h0a7.61,7.61,0,0,0-1.05.07,9.85,9.85,0,0,0-5,2.21,6.92,6.92,0,0,0-2.89,5.34A3.84,3.84,0,0,0,119,83.73a6.07,6.07,0,0,0,2.75.61,9.46,9.46,0,0,0,1.17-.08,10.13,10.13,0,0,0,5-2.14c2-1.55,3-3.34,3-5.3a3.82,3.82,0,0,0-2.27-3.58,5.82,5.82,0,0,0-2.87-.71Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3ba5e327.svg";
export { ForwardRef as ReactComponent };